import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useFetchData } from './queryUtil';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ActionType: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  EntityType: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AddLoansToPoolFromFilterInput = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  elementSetting: Scalars['JSON']['input'];
  excludedLoanNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  poolId: Scalars['Int']['input'];
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
  portfolioId: Scalars['Int']['input'];
};

export type AddPoolLoanInput = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  loanNumber?: InputMaybe<Scalars['String']['input']>;
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  poolId: Scalars['ID']['input'];
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
};

export type Agreement_ExportAcceptancesInput = {
  acceptedAfter?: InputMaybe<Scalars['String']['input']>;
  acceptedBefore?: InputMaybe<Scalars['String']['input']>;
  institutionIds: Array<Scalars['Int']['input']>;
};

export type Agreement_PublishVersionInput = {
  content: Scalars['String']['input'];
  requireAcceptance: Scalars['Boolean']['input'];
};

export enum AuditEventType {
  Insert = 'INSERT',
  Modify = 'MODIFY',
  Remove = 'REMOVE'
}

/** [EXPERIMENTAL] Filter for audit log query. */
export type AuditLogFilterInput = {
  /** Filter by event type(s). If empty, include all. */
  eventTypes?: InputMaybe<Array<AuditEventType>>;
  /** Filter by origin ID (partial match). */
  originId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by origin type (partial match). */
  originType?: InputMaybe<Scalars['String']['input']>;
  /** Filter by role (exact match). */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Filter by target ID (partial match). */
  targetId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by target type (partial match). */
  targetType?: InputMaybe<Scalars['String']['input']>;
  /** Filter by principal who performed the change (partial match). */
  upsertedBy?: InputMaybe<Scalars['String']['input']>;
};

export type AuthPreviewMigrationRecordsInput = {
  /** Optional cursor from the previous result for pagination. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Job ID to preview (e.g., 'backfill-upserted', 'migrate-healthcheck'). */
  jobId: Scalars['String']['input'];
};

export type AuthQueryMigrationStatusInput = {
  /** Filter by job ID (e.g., 'backfill-upserted'). Optional — omit to list all available jobs. */
  jobId?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of results to return. Default 10. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by status: 'running', 'completed', or 'failed'. Optional. */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AuthRunMigrationJobInput = {
  /** If true, clear any stored checkpoint and run job from the start. */
  clearState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job identifier (e.g., 'backfill-upserted', 'migrate-healthcheck'). */
  jobId: Scalars['String']['input'];
  /** Job-specific parameters as JSON. Schema varies by job — use auth_queryMigrationStatus to discover accepted params. */
  params?: InputMaybe<Scalars['JSON']['input']>;
};

export type AuthTestMigrationParamsInput = {
  /** Job ID to test (e.g., 'backfill-upserted'). */
  jobId: Scalars['String']['input'];
  /** Maximum number of matched records to return. Default 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Parameters to pass to the job's filter function. */
  params: Scalars['JSON']['input'];
};

/** Input for batch scanEdge queries. */
export type Auth_BatchScanEdgeInput = {
  /** Batch of edge scan configurations. */
  scans: Array<Auth_ScanEdgeInput>;
};

/** Input for edge update (upsert or delete) after authorization check. Principal is derived from JWT. */
export type Auth_EdgeUpdateInput = {
  /** Edge/role name to add or remove (clean path without storage prefixes). */
  edge: Scalars['String']['input'];
  /** Edge type: 'member' for parent-child membership relationships, 'attribute' for attribute edges. Defaults to 'attribute'. */
  edgeType?: InputMaybe<Scalars['String']['input']>;
  /** Entity ID of resource being modified. */
  originId: Scalars['String']['input'];
  /** Entity type of resource being modified. */
  originType: Scalars['String']['input'];
  /** Target entity ID to link. */
  targetId: Scalars['String']['input'];
  /** Target entity type to link. */
  targetType: Scalars['String']['input'];
  /** When true, soft-delete the edge (tombstone). When false or omitted, upsert (create/update). */
  tombstone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Seed entity input for auth_scanEntities. */
export type Auth_EntitySeedInput = {
  /** Entity ID. */
  entityId: Scalars['String']['input'];
  /** Cedar entity type (e.g. PAX::MKT_INSTITUTION). */
  entityType: Scalars['String']['input'];
};

/** Input for auth_scanEdge query. */
export type Auth_ScanEdgeInput = {
  /** Edge path (e.g., 'institution' or 'membership.member'). */
  edge: Scalars['String']['input'];
  /** Edge type: 'member' for membership edges, 'attribute' for attribute edges. Defaults to 'attribute'. */
  edgeType?: InputMaybe<Scalars['String']['input']>;
  /** Include tombstoned (soft-deleted) edges. Default false. */
  includeTombstone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Origin entity ID, or null to discover origins. */
  originId?: InputMaybe<Scalars['String']['input']>;
  /** Origin entity type. */
  originType: Scalars['String']['input'];
  /** Entity types to exclude from suppression during hydration (e.g., ['PAX::User']). */
  skipSuppression?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Target entity ID, or null to discover targets. */
  targetId?: InputMaybe<Scalars['String']['input']>;
  /** Target entity type. */
  targetType: Scalars['String']['input'];
};

export type ChangeLoanNumberInput = {
  clientId: Scalars['Int']['input'];
  currentLoanNumber: Scalars['String']['input'];
  newLoanNumber: Scalars['String']['input'];
};

export type CreateBuyFilterInput = {
  filter: Scalars['JSON']['input'];
  filterName: Scalars['String']['input'];
};

export type CreateClientInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  c0Number?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInitialSettlementCommissionInput = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['String']['input'];
  poolId: Scalars['ID']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLoanInput = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loanNumber: Scalars['String']['input'];
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  maturityDate?: InputMaybe<Scalars['String']['input']>;
  originalBalance?: InputMaybe<Scalars['Float']['input']>;
  originationDate?: InputMaybe<Scalars['String']['input']>;
  paxLoanIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePoolBuyRequestInput = {
  assetClass: PoolType;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  poolSizeMax?: InputMaybe<Scalars['Decimal']['input']>;
  poolSizeMin?: InputMaybe<Scalars['Decimal']['input']>;
  targetYield?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreatePoolBuyRequestInquiryInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  poolBuyRequestId: Scalars['Int']['input'];
};

export type CreatePoolFromFilterInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  elementSetting: Scalars['JSON']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  excludedLoanNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRecourse?: InputMaybe<Scalars['Boolean']['input']>;
  loanPortfolioId?: InputMaybe<Scalars['Int']['input']>;
  platformFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
  poolName?: InputMaybe<Scalars['String']['input']>;
  poolNumber: Scalars['String']['input'];
  poolStatus?: InputMaybe<PoolStatus>;
  poolType?: InputMaybe<PoolType>;
  portfolioId: Scalars['Int']['input'];
  servicingFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePoolInput = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRecourse?: InputMaybe<Scalars['Boolean']['input']>;
  loanPortfolioId?: InputMaybe<Scalars['Int']['input']>;
  platformFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  poolName?: InputMaybe<Scalars['String']['input']>;
  poolNumber: Scalars['String']['input'];
  poolStatus?: InputMaybe<PoolStatus>;
  poolType?: InputMaybe<PoolType>;
  servicingFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePoolListingInput = {
  carveOutPermitted?: InputMaybe<Scalars['Boolean']['input']>;
  dueDiligencePeriod?: InputMaybe<DueDiligencePeriod>;
  dueDiligencePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  institutionNameDisclosure?: InputMaybe<InstitutionNameDisclosure>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  listingDate?: InputMaybe<Scalars['String']['input']>;
  listingPercentage?: InputMaybe<Scalars['Float']['input']>;
  listingStage?: InputMaybe<PoolListingStage>;
  listingStatus?: InputMaybe<PoolListingStatus>;
  listingType?: InputMaybe<PoolListingType>;
  minBuyinType?: InputMaybe<PoolListingBuyinType>;
  minBuyinValue?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  poolId?: InputMaybe<Scalars['ID']['input']>;
  poolNumber?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  recourseType?: InputMaybe<RecourseType>;
  servicingType?: InputMaybe<ServicingType>;
  settlementType?: InputMaybe<SettlementType>;
};

export type CreatePoolLoanInput = {
  clientId: Scalars['Int']['input'];
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  loanId: Scalars['ID']['input'];
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  poolId: Scalars['ID']['input'];
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
};

export type CreatePoolLoanStagingInput = {
  buyerId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  createdBy: Scalars['String']['input'];
  loanId: Scalars['ID']['input'];
  loanPoolFlag: LoanPoolFlag;
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  poolId: Scalars['ID']['input'];
  status?: InputMaybe<PoolLoanStagingStatus>;
};

export type CreatePoolParticipantInput = {
  buyerId: Scalars['Int']['input'];
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isServicer?: InputMaybe<Scalars['Boolean']['input']>;
  paysPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  percentage: Scalars['Float']['input'];
  poolId: Scalars['ID']['input'];
  pricePaid?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRemittanceHistoryInput = {
  currentStep?: InputMaybe<RemittanceStep>;
  poolId: Scalars['ID']['input'];
  reportingPeriod: Scalars['String']['input'];
  status?: InputMaybe<RemittanceStatus>;
};

export type CreateRemittanceStagingBulkInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  inputs: Array<CreateRemittanceStagingInput>;
};

export type CreateRemittanceStagingInput = {
  accruedInterest?: InputMaybe<Scalars['Float']['input']>;
  additionalFields?: InputMaybe<Scalars['String']['input']>;
  amountPastDue?: InputMaybe<Scalars['Float']['input']>;
  bankruptcyChapter?: InputMaybe<Scalars['Int']['input']>;
  bankruptcyDate?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Scalars['String']['input']>;
  buybackAmount?: InputMaybe<Scalars['Float']['input']>;
  chargeOffAmount?: InputMaybe<Scalars['Float']['input']>;
  chargeOffBalance?: InputMaybe<Scalars['Float']['input']>;
  chargeOffDate?: InputMaybe<Scalars['String']['input']>;
  chargeOffType?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['Int']['input'];
  coreLoanId?: InputMaybe<Scalars['String']['input']>;
  cpiInsRefund?: InputMaybe<Scalars['Float']['input']>;
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  currentInterestRate?: InputMaybe<Scalars['Float']['input']>;
  daysPastDue?: InputMaybe<Scalars['Int']['input']>;
  delinquentEver?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate: Scalars['String']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  interestPaid?: InputMaybe<Scalars['Float']['input']>;
  isBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
  isFrozen?: InputMaybe<Scalars['Boolean']['input']>;
  isNonAccrual?: InputMaybe<Scalars['Boolean']['input']>;
  isReversal?: InputMaybe<Scalars['Boolean']['input']>;
  isTdr?: InputMaybe<Scalars['Boolean']['input']>;
  lastPaymentDate?: InputMaybe<Scalars['String']['input']>;
  lateFeesPaid?: InputMaybe<Scalars['Float']['input']>;
  loanClientId?: InputMaybe<Scalars['Int']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  loanLevelServiceFee?: InputMaybe<Scalars['Float']['input']>;
  loanNumber?: InputMaybe<Scalars['String']['input']>;
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  loanSubcategoryId?: InputMaybe<Scalars['Int']['input']>;
  loanType?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDate?: InputMaybe<Scalars['String']['input']>;
  nonAccrualDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherFeeIndicator?: InputMaybe<Scalars['String']['input']>;
  otherFeesPaid?: InputMaybe<Scalars['Float']['input']>;
  paProcessedDate?: InputMaybe<Scalars['String']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  poolId?: InputMaybe<Scalars['ID']['input']>;
  poolNumber?: InputMaybe<Scalars['String']['input']>;
  principalPaid?: InputMaybe<Scalars['Float']['input']>;
  receivedDate: Scalars['String']['input'];
  recoveryAmount?: InputMaybe<Scalars['Float']['input']>;
  recoveryBalance?: InputMaybe<Scalars['Float']['input']>;
  recoveryDate?: InputMaybe<Scalars['String']['input']>;
  reportingPeriod: Scalars['String']['input'];
  scheduledPayment?: InputMaybe<Scalars['Float']['input']>;
};

export enum DebitCredit {
  C = 'C',
  D = 'D'
}

export enum Decision {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export enum DueDiligencePeriod {
  ClosedEnded = 'CLOSED_ENDED',
  OpenEnded = 'OPEN_ENDED'
}

export enum ExpandEntityIdField {
  ResourceId = 'resourceId'
}

export type ExpressInterestInput = {
  buyerContactEmail: Scalars['String']['input'];
  buyerContactName: Scalars['String']['input'];
  buyerMessage?: InputMaybe<Scalars['String']['input']>;
  poolId: Scalars['Int']['input'];
};

export type FindOrCreateCarveOutInput = {
  buyerId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  createdBy: Scalars['String']['input'];
  poolId: Scalars['ID']['input'];
};

export type GenerateIdentifierInput = {
  assetClass: Scalars['String']['input'];
  financialId: Scalars['Int']['input'];
};

export type GeneratePoolNumberAndNameInput = {
  assetClass: Scalars['String']['input'];
  financialId: Scalars['Int']['input'];
};

export type GeneratePoolNumberInput = {
  assetClass: Scalars['String']['input'];
};

/** [EXPERIMENTAL] Input for get audit logs query. */
export type GetAuditLogsInput = {
  /** End of time range (ISO 8601 or epoch ms). Inclusive. */
  endTime: Scalars['String']['input'];
  /** Optional filters. */
  filter?: InputMaybe<AuditLogFilterInput>;
  /** Max entries to return. Default 500, max 2000. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of matching entries to skip before returning. For pagination. Default 0. */
  skipCount?: InputMaybe<Scalars['Int']['input']>;
  /** Start of time range (ISO 8601 or epoch ms). Inclusive. */
  startTime: Scalars['String']['input'];
};

export type HealthCheckInput = {
  /** Run full JWT validator suite (all 16 tests). Default false runs lightweight test. */
  doFull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InitRemittanceHistoryInput = {
  mpaDeadline?: InputMaybe<Scalars['String']['input']>;
  poolId: Scalars['ID']['input'];
  reportingPeriod: Scalars['String']['input'];
};

export enum InstitutionNameDisclosure {
  Immediately = 'IMMEDIATELY',
  Loi = 'LOI',
  Manual = 'MANUAL',
  Nda = 'NDA'
}

export enum InstitutionType {
  AutoFinance = 'autoFinance',
  Bank = 'bank',
  CreditUnion = 'creditUnion',
  Other = 'other'
}

export type LeadershipMemberInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum LoanLookupStatus {
  Found = 'FOUND',
  NotFound = 'NOT_FOUND'
}

export enum LoanPoolFlag {
  Added = 'ADDED',
  Original = 'ORIGINAL',
  Removed = 'REMOVED'
}

export type LoanStatusForPoolInput = {
  loanNumbers: Array<Scalars['String']['input']>;
  poolId?: InputMaybe<Scalars['ID']['input']>;
  poolNumber?: InputMaybe<Scalars['String']['input']>;
};

export type LoanStatusInput = {
  loanNumbers: Array<Scalars['String']['input']>;
};

export enum MpAdminAccess {
  Full = 'full',
  View = 'view'
}

export enum MarketPoolScope {
  IncludeSeller = 'INCLUDE_SELLER',
  SellerOnly = 'SELLER_ONLY'
}

export type OriginAssignmentInput = {
  role: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  targetType: Scalars['String']['input'];
};

export enum PaSolver_AggType {
  CompositeRisk = 'composite_risk',
  CorrelationDiversity = 'correlation_diversity',
  Formula = 'formula',
  Hhi = 'hhi',
  MaxShare = 'max_share',
  Ratio = 'ratio',
  ResidualHhi = 'residual_hhi',
  ResidualRatio = 'residual_ratio',
  ResidualWa = 'residual_wa',
  Wa = 'wa'
}

export enum PaSolver_AnalyticsAction {
  Diversification = 'diversification',
  DiversificationTargets = 'diversification_targets',
  PoolScore = 'pool_score',
  RankPools = 'rank_pools',
  RiskScore = 'risk_score',
  Sandbox = 'sandbox'
}

export type PaSolver_AnalyticsInput = {
  action: PaSolver_AnalyticsAction;
  buyLoanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dataDate?: InputMaybe<Scalars['String']['input']>;
  loanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  poolId?: InputMaybe<Scalars['String']['input']>;
  poolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  portfolioId: Scalars['String']['input'];
  sellLoanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  zipBalances?: InputMaybe<Scalars['JSON']['input']>;
};

export type PaSolver_BatchAnalyticsInput = {
  dataDate?: InputMaybe<Scalars['String']['input']>;
};

export type PaSolver_BatchSolveInput = {
  batchSize: Scalars['Int']['input'];
  dataDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PaSolver_FilterStateInput>;
  metrics: Array<PaSolver_MetricDefInput>;
  perspective: PaSolver_Perspective;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  restarts?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  sizeTolerance?: InputMaybe<Scalars['Float']['input']>;
  targetSize: Scalars['Float']['input'];
  timeBudgetMs?: InputMaybe<Scalars['Int']['input']>;
  weights: Scalars['JSON']['input'];
};

export enum PaSolver_Confidence {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum PaSolver_CorrelationSource {
  CbsaMonthlyRates = 'cbsa_monthly_rates',
  DsH3 = 'ds_h3'
}

export enum PaSolver_Direction {
  Maximize = 'maximize',
  Minimize = 'minimize',
  Target = 'target'
}

export type PaSolver_FilterStateInput = {
  loanType?: InputMaybe<Array<Scalars['String']['input']>>;
  rateMax?: InputMaybe<Scalars['Float']['input']>;
  rateMin?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum PaSolver_ImpactTier {
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum PaSolver_JobStatusEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type PaSolver_MarketplaceInput = {
  dataDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PaSolver_FilterStateInput>;
  maxPortfolios?: InputMaybe<Scalars['Int']['input']>;
  metrics: Array<PaSolver_MetricDefInput>;
  minBalanceRatio?: InputMaybe<Scalars['Float']['input']>;
  minFieldCoverage?: InputMaybe<Scalars['Float']['input']>;
  minLoanCount?: InputMaybe<Scalars['Int']['input']>;
  restarts?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  sizeTolerance?: InputMaybe<Scalars['Float']['input']>;
  targetSize: Scalars['Float']['input'];
  timeBudgetMs?: InputMaybe<Scalars['Int']['input']>;
  weights: Scalars['JSON']['input'];
  workers?: InputMaybe<Scalars['Int']['input']>;
};

export type PaSolver_MetricDefInput = {
  agg: PaSolver_AggType;
  denField?: InputMaybe<Scalars['String']['input']>;
  direction: PaSolver_Direction;
  field?: InputMaybe<Scalars['String']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  hardMax?: InputMaybe<Scalars['Float']['input']>;
  hardMin?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  numField?: InputMaybe<Scalars['String']['input']>;
  referenceKey?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

export enum PaSolver_Perspective {
  Buyer = 'buyer',
  Seller = 'seller'
}

export type PaSolver_SolveInput = {
  dataDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PaSolver_FilterStateInput>;
  metrics: Array<PaSolver_MetricDefInput>;
  perspective: PaSolver_Perspective;
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  restarts?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  sizeTolerance?: InputMaybe<Scalars['Float']['input']>;
  targetSize: Scalars['Float']['input'];
  timeBudgetMs?: InputMaybe<Scalars['Int']['input']>;
  weights: Scalars['JSON']['input'];
};

export enum PaSolver_TensionSeverity {
  High = 'high',
  Moderate = 'moderate'
}

export type PaSolver_WarmInput = {
  dataDate?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionInput = {
  actionId: Scalars['String']['input'];
  actionType: Scalars['ActionType']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  principalId: Scalars['String']['input'];
  principalType: Scalars['EntityType']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['EntityType']['input'];
};

export enum PoolBuyRequestStatus {
  Active = 'ACTIVE',
  Withdrawn = 'WITHDRAWN'
}

export enum PoolListingBuyinType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export enum PoolListingStage {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  ReadyToPublish = 'READY_TO_PUBLISH'
}

export enum PoolListingStatus {
  Available = 'AVAILABLE',
  Listed = 'LISTED',
  Sold = 'SOLD',
  Unlisted = 'UNLISTED'
}

export enum PoolListingType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum PoolLoanNodeStatus {
  Found = 'FOUND',
  NotFound = 'NOT_FOUND'
}

export enum PoolLoanStagingStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  BoughtBack = 'BOUGHT_BACK',
  Draft = 'DRAFT',
  Negotiating = 'NEGOTIATING',
  PaidOff = 'PAID_OFF',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Sold = 'SOLD',
  Submitted = 'SUBMITTED'
}

export enum PoolLoanStatus {
  Active = 'ACTIVE',
  BoughtBack = 'BOUGHT_BACK',
  PaidOff = 'PAID_OFF',
  Removed = 'REMOVED',
  Sold = 'SOLD'
}

export enum PoolRole {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export enum PoolStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum PoolTier {
  Market = 'MARKET',
  Participant = 'PARTICIPANT',
  Seller = 'SELLER'
}

export enum PoolType {
  Auto = 'AUTO',
  Cre = 'CRE',
  Heloc = 'HELOC',
  Mortgage = 'MORTGAGE',
  Recreation = 'RECREATION',
  Unsecured = 'UNSECURED'
}

export enum RecourseType {
  FullRecourse = 'FULL_RECOURSE',
  NonRecourse = 'NON_RECOURSE'
}

export enum RemittanceStagingStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Cancelled = 'CANCELLED',
  DataPending = 'DATA_PENDING',
  InReview = 'IN_REVIEW',
  ReadyToReview = 'READY_TO_REVIEW'
}

export enum RemittanceStatus {
  Acknowledged = 'ACKNOWLEDGED',
  AwaitingData = 'AWAITING_DATA',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  CompletedBySystem = 'COMPLETED_BY_SYSTEM',
  DataPending = 'DATA_PENDING',
  InReview = 'IN_REVIEW',
  ReadyToReview = 'READY_TO_REVIEW'
}

export enum RemittanceStep {
  AccrualsAndNonAccruals = 'ACCRUALS_AND_NON_ACCRUALS',
  ActiveBalances = 'ACTIVE_BALANCES',
  BuyBack = 'BUY_BACK',
  ChargeOffActivity = 'CHARGE_OFF_ACTIVITY',
  DataReceived = 'DATA_RECEIVED',
  Delinquencies = 'DELINQUENCIES',
  DrawRevolvingActivity = 'DRAW_REVOLVING_ACTIVITY',
  FeesAndExpenses = 'FEES_AND_EXPENSES',
  MaturedAndPrePay = 'MATURED_AND_PRE_PAY',
  PaymentTransactions = 'PAYMENT_TRANSACTIONS',
  RemittanceReview = 'REMITTANCE_REVIEW'
}

export type Report_ChartOptionsInput = {
  chartType?: InputMaybe<Report_ElementChartType>;
  chartsPerRow?: InputMaybe<Scalars['Int']['input']>;
  colorType?: InputMaybe<Scalars['String']['input']>;
  colorsList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showLabels?: InputMaybe<Scalars['Boolean']['input']>;
  showLegend?: InputMaybe<Scalars['Boolean']['input']>;
  splitStrat?: InputMaybe<Scalars['Boolean']['input']>;
  universalAxis?: InputMaybe<Scalars['Boolean']['input']>;
  verticalDataLabels?: InputMaybe<Scalars['Boolean']['input']>;
  xAxisTitle?: InputMaybe<Scalars['String']['input']>;
};

export enum Report_ColumnType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Link = 'LINK',
  Number = 'NUMBER',
  String = 'STRING'
}

export enum Report_DataLevel {
  UserPool = 'USER_POOL',
  UserPortfolio = 'USER_PORTFOLIO'
}

export enum Report_ElementChartType {
  Area = 'area',
  Bar = 'bar',
  Column = 'column',
  Donut = 'donut',
  Line = 'line',
  Pie = 'pie',
  Spline = 'spline',
  StackedArea = 'stackedArea',
  StackedBar = 'stackedBar',
  StackedColumn = 'stackedColumn',
  StackedPercentageColumn = 'stackedPercentageColumn'
}

export type Report_ElementQueryOptionsInput = {
  chartOptions?: InputMaybe<Report_ChartOptionsInput>;
  countPrecision?: InputMaybe<Scalars['Int']['input']>;
  countRounding?: InputMaybe<Report_RoundingValue>;
  dollarPrecision?: InputMaybe<Scalars['Int']['input']>;
  dollarRounding?: InputMaybe<Report_RoundingValue>;
  filter?: InputMaybe<Report_FilterInput>;
  groupBy?: InputMaybe<Array<Report_GroupByInput>>;
  numberPrecision?: InputMaybe<Scalars['Int']['input']>;
  numberRounding?: InputMaybe<Report_RoundingValue>;
  optionsSetting?: InputMaybe<Report_OptionsSettingInput>;
  orderBySetting?: InputMaybe<Report_OrderBySettingInput>;
  paginationSetting?: InputMaybe<Report_PaginationSettingInput>;
  ratioPrecision?: InputMaybe<Scalars['Int']['input']>;
  ratioRounding?: InputMaybe<Report_RoundingValue>;
  showOption: Array<Report_SelectFieldInput>;
  timePeriodSetting?: InputMaybe<Report_TimePeriodSettingInput>;
};

export type Report_ElementSettingsInput = {
  dataDateString: Scalars['String']['input'];
  loanIdNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  queryOptions?: InputMaybe<Report_ElementQueryOptionsInput>;
};

export enum Report_ElementStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export enum Report_ElementType {
  Box = 'BOX',
  Chart = 'CHART',
  InverseTable = 'INVERSE_TABLE',
  List = 'LIST',
  Matrix = 'MATRIX',
  Migration = 'MIGRATION',
  MultilineBox = 'MULTILINE_BOX',
  StaticPoolComparison = 'STATIC_POOL_COMPARISON',
  Table = 'TABLE',
  TrendChart = 'TREND_CHART',
  TrendTable = 'TREND_TABLE'
}

export type Report_FilterFieldConditionInput = {
  between?: InputMaybe<Report_FilterFieldRangeInput>;
  equal?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  notEqual?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Report_FilterFieldInput = {
  condition: Report_FilterFieldConditionInput;
  field: Scalars['String']['input'];
};

export type Report_FilterFieldRangeInput = {
  max: Scalars['String']['input'];
  min: Scalars['String']['input'];
};

export type Report_FilterInput = {
  filterParts?: InputMaybe<Array<Report_FilterPartInput>>;
  logic?: InputMaybe<Scalars['String']['input']>;
};

export type Report_FilterPartInput = {
  filterFields: Array<Report_FilterFieldInput>;
  /**
   * Restricts this part to one saved group's members, sent as the group id so the query engine
   *   resolves membership with a subquery. Prefer it over enumerating the group's loan ids: an id
   *   list binds one parameter per loan and fails outright on a large group, while this binds two
   *   regardless of group size. A part may carry this alone, with filterFields empty.
   */
  inSavedGroup?: InputMaybe<Scalars['Int']['input']>;
  not: Scalars['Boolean']['input'];
};

export enum Report_FilterType {
  ChargeOffLookback = 'CHARGE_OFF_LOOKBACK',
  ChargeOffRange = 'CHARGE_OFF_RANGE',
  IncludeExclude = 'INCLUDE_EXCLUDE',
  MinMax = 'MIN_MAX',
  Picklist = 'PICKLIST',
  Textbox = 'TEXTBOX',
  TrueFalse = 'TRUE_FALSE'
}

export type Report_GroupByInput = {
  canTier?: InputMaybe<Scalars['Boolean']['input']>;
  customTierId?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum Report_LookbackType {
  Custom = 'CUSTOM',
  LastYear = 'LAST_YEAR',
  YearToDate = 'YEAR_TO_DATE'
}

export enum Report_MigrationMethod {
  DateRange = 'DATE_RANGE',
  LookBack = 'LOOK_BACK',
  Stratification = 'STRATIFICATION'
}

export type Report_OptionsSettingInput = {
  includeGroupFieldTotals?: InputMaybe<Scalars['Boolean']['input']>;
  isMigration?: InputMaybe<Scalars['Boolean']['input']>;
  migrationMethod?: InputMaybe<Report_MigrationMethod>;
  shouldGetSubtotals?: InputMaybe<Scalars['Boolean']['input']>;
  skipExecution?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Report_OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Report_OrderByInput = {
  direction: Report_OrderByDirection;
  returnHeader?: InputMaybe<Scalars['String']['input']>;
  type: Report_OrderByType;
};

export type Report_OrderBySettingInput = {
  primary: Report_OrderByInput;
  secondary?: InputMaybe<Report_OrderByInput>;
};

export enum Report_OrderByType {
  GroupBy = 'GROUP_BY',
  SelectField = 'SELECT_FIELD'
}

export type Report_PaginationSettingInput = {
  orderByDirection?: InputMaybe<Scalars['String']['input']>;
  orderByField: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Report_PeriodInput = {
  period: Scalars['Int']['input'];
  periodType: Report_PeriodType;
};

export enum Report_PeriodType {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR',
  Yeartodate = 'YEARTODATE'
}

export enum Report_RoundingValue {
  Billions = 'Billions',
  Millions = 'Millions',
  None = 'None',
  Thousands = 'Thousands'
}

export type Report_SelectFieldInput = {
  alias: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  field: Scalars['String']['input'];
  periodOptions?: InputMaybe<Report_PeriodInput>;
};

export enum Report_ShareStatus {
  Edit = 'edit',
  None = 'none',
  View = 'view'
}

export type Report_TimePeriodSettingInput = {
  datesAsc?: InputMaybe<Scalars['Boolean']['input']>;
  lookbackPeriod?: InputMaybe<Scalars['Int']['input']>;
  lookbackType: Report_LookbackType;
  periodType: Report_PeriodType;
  showAbsoluteChange?: InputMaybe<Scalars['Boolean']['input']>;
  showAverage?: InputMaybe<Scalars['Boolean']['input']>;
  showEndToEnd?: InputMaybe<Scalars['Boolean']['input']>;
  showPercentChange?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Report_ValueType {
  Count = 'COUNT',
  Date = 'DATE',
  Dollar = 'DOLLAR',
  Number = 'NUMBER',
  Ratio = 'RATIO',
  String = 'STRING'
}

export type RoleAssignmentInput = {
  /** DEPRECATED: context is ignored. Server-side authorization context (e.g., actingAgent) is extracted only from JWT claims to prevent untrusted user input from influencing authorization decisions. */
  context?: InputMaybe<Scalars['String']['input']>;
  originId: Scalars['String']['input'];
  originType: Scalars['String']['input'];
  role: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  targetType: Scalars['String']['input'];
};

export enum ServicingType {
  Retained = 'RETAINED',
  Transferred = 'TRANSFERRED'
}

export type SetOriginAssignmentsInput = {
  assignments: Array<OriginAssignmentInput>;
  originId: Scalars['String']['input'];
  originType: Scalars['String']['input'];
  partialUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SettlementType {
  Participation = 'PARTICIPATION',
  WholeLoan = 'WHOLE_LOAN'
}

export type SubmitCarveOutInput = {
  carveOutId: Scalars['ID']['input'];
  modifiedBy: Scalars['String']['input'];
};

export type UpdateBuyFilterInput = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateCarveOutStatusInput = {
  carveOutId: Scalars['ID']['input'];
  modifiedBy: Scalars['String']['input'];
  status: PoolLoanStagingStatus;
};

export type UpdateClientInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  c0Number?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLoanFlagInput = {
  carveOutId: Scalars['ID']['input'];
  flag: LoanPoolFlag;
  loanId: Scalars['ID']['input'];
  modifiedBy: Scalars['String']['input'];
};

export type UpdateLoanInput = {
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  maturityDate?: InputMaybe<Scalars['String']['input']>;
  originalBalance?: InputMaybe<Scalars['Float']['input']>;
  originationDate?: InputMaybe<Scalars['String']['input']>;
  paxLoanIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePoolInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRecourse?: InputMaybe<Scalars['Boolean']['input']>;
  loanPortfolioId?: InputMaybe<Scalars['Int']['input']>;
  platformFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  poolName?: InputMaybe<Scalars['String']['input']>;
  poolStatus?: InputMaybe<PoolStatus>;
  poolType?: InputMaybe<PoolType>;
  servicingFeePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePoolListingInput = {
  carveOutPermitted?: InputMaybe<Scalars['Boolean']['input']>;
  delistedDate?: InputMaybe<Scalars['String']['input']>;
  dueDiligencePeriod?: InputMaybe<DueDiligencePeriod>;
  dueDiligencePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  institutionNameDisclosure?: InputMaybe<InstitutionNameDisclosure>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  listingDate?: InputMaybe<Scalars['String']['input']>;
  listingPercentage?: InputMaybe<Scalars['Float']['input']>;
  listingStage?: InputMaybe<PoolListingStage>;
  listingStatus?: InputMaybe<PoolListingStatus>;
  listingType?: InputMaybe<PoolListingType>;
  minBuyinType?: InputMaybe<PoolListingBuyinType>;
  minBuyinValue?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  recourseType?: InputMaybe<RecourseType>;
  servicingType?: InputMaybe<ServicingType>;
  settlementType?: InputMaybe<SettlementType>;
  soldDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePoolLoanInput = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
};

export type UpdatePoolLoanStagingInput = {
  loanPoolFlag?: InputMaybe<LoanPoolFlag>;
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PoolLoanStagingStatus>;
};

export type UpdatePoolMetricsInput = {
  grossYield?: InputMaybe<Scalars['Float']['input']>;
  netYield?: InputMaybe<Scalars['Float']['input']>;
  waFico?: InputMaybe<Scalars['Int']['input']>;
  waLtv?: InputMaybe<Scalars['Float']['input']>;
  war?: InputMaybe<Scalars['Float']['input']>;
  warl?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePoolParticipantInput = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isServicer?: InputMaybe<Scalars['Boolean']['input']>;
  paysPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  pricePaid?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRemittanceHistoryInput = {
  buyerAcknowledgeDate?: InputMaybe<Scalars['String']['input']>;
  currentStep?: InputMaybe<RemittanceStep>;
  dataConfirmation?: InputMaybe<Scalars['String']['input']>;
  dataSent?: InputMaybe<Scalars['Boolean']['input']>;
  mpaDeadline?: InputMaybe<Scalars['String']['input']>;
  processDate?: InputMaybe<Scalars['String']['input']>;
  sellerAcknowledgeDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RemittanceStatus>;
};

export type UpdateRemittanceStagingInput = {
  additionalFields?: InputMaybe<Scalars['String']['input']>;
  amountPastDue?: InputMaybe<Scalars['Float']['input']>;
  bankruptcyChapter?: InputMaybe<Scalars['Int']['input']>;
  bankruptcyDate?: InputMaybe<Scalars['String']['input']>;
  chargeOffBalance?: InputMaybe<Scalars['Float']['input']>;
  chargeOffDate?: InputMaybe<Scalars['String']['input']>;
  chargeOffType?: InputMaybe<Scalars['String']['input']>;
  coreLoanId?: InputMaybe<Scalars['String']['input']>;
  cpiInsRefund?: InputMaybe<Scalars['Float']['input']>;
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  currentInterestRate?: InputMaybe<Scalars['Float']['input']>;
  daysPastDue?: InputMaybe<Scalars['Int']['input']>;
  delinquentEver?: InputMaybe<Scalars['Boolean']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  isBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
  isFrozen?: InputMaybe<Scalars['Boolean']['input']>;
  isNonAccrual?: InputMaybe<Scalars['Boolean']['input']>;
  isReversal?: InputMaybe<Scalars['Boolean']['input']>;
  isTdr?: InputMaybe<Scalars['Boolean']['input']>;
  lastPaymentDate?: InputMaybe<Scalars['String']['input']>;
  loanClientId?: InputMaybe<Scalars['Int']['input']>;
  loanLevelServiceFee?: InputMaybe<Scalars['Float']['input']>;
  loanNumber?: InputMaybe<Scalars['String']['input']>;
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  loanSubcategoryId?: InputMaybe<Scalars['Int']['input']>;
  loanType?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDate?: InputMaybe<Scalars['String']['input']>;
  nonAccrualDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherFeeIndicator?: InputMaybe<Scalars['String']['input']>;
  paProcessedDate?: InputMaybe<Scalars['String']['input']>;
  recoveryBalance?: InputMaybe<Scalars['Float']['input']>;
  recoveryDate?: InputMaybe<Scalars['String']['input']>;
  scheduledPayment?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateStagingRemittanceNotesInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  stagingRemittanceId: Scalars['ID']['input'];
};

export type UpsertLoanInput = {
  clientId: Scalars['Int']['input'];
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loanNumber: Scalars['String']['input'];
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  maturityDate?: InputMaybe<Scalars['String']['input']>;
  originalBalance?: InputMaybe<Scalars['Float']['input']>;
  originationDate?: InputMaybe<Scalars['String']['input']>;
  paxLoanIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertPoolLoanInput = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  loanNumber?: InputMaybe<Scalars['String']['input']>;
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  poolId: Scalars['ID']['input'];
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
};

export type UpsertPoolLoanStagingInput = {
  buyerId: Scalars['Int']['input'];
  clientId: Scalars['Int']['input'];
  createdBy: Scalars['String']['input'];
  loanId: Scalars['ID']['input'];
  loanPoolFlag: LoanPoolFlag;
  originalSalesPrice?: InputMaybe<Scalars['Float']['input']>;
  poolId: Scalars['ID']['input'];
  status?: InputMaybe<PoolLoanStagingStatus>;
};

export type UpsertRemittanceStagingInput = {
  accruedInterest?: InputMaybe<Scalars['Float']['input']>;
  additionalFields?: InputMaybe<Scalars['String']['input']>;
  amountPastDue?: InputMaybe<Scalars['Float']['input']>;
  bankruptcyChapter?: InputMaybe<Scalars['Int']['input']>;
  bankruptcyDate?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Scalars['String']['input']>;
  buybackAmount?: InputMaybe<Scalars['Float']['input']>;
  chargeOffAmount?: InputMaybe<Scalars['Float']['input']>;
  chargeOffBalance?: InputMaybe<Scalars['Float']['input']>;
  chargeOffDate?: InputMaybe<Scalars['String']['input']>;
  chargeOffType?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['Int']['input'];
  coreLoanId?: InputMaybe<Scalars['String']['input']>;
  cpiInsRefund?: InputMaybe<Scalars['Float']['input']>;
  creditLimit?: InputMaybe<Scalars['Float']['input']>;
  currentBalance?: InputMaybe<Scalars['Float']['input']>;
  currentInterestRate?: InputMaybe<Scalars['Float']['input']>;
  daysPastDue?: InputMaybe<Scalars['Int']['input']>;
  delinquentEver?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate: Scalars['String']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  interestPaid?: InputMaybe<Scalars['Float']['input']>;
  isBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
  isFrozen?: InputMaybe<Scalars['Boolean']['input']>;
  isNonAccrual?: InputMaybe<Scalars['Boolean']['input']>;
  isReversal?: InputMaybe<Scalars['Boolean']['input']>;
  isTdr?: InputMaybe<Scalars['Boolean']['input']>;
  lastPaymentDate?: InputMaybe<Scalars['String']['input']>;
  lateFeesPaid?: InputMaybe<Scalars['Float']['input']>;
  loanClientId?: InputMaybe<Scalars['Int']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  loanLevelServiceFee?: InputMaybe<Scalars['Float']['input']>;
  loanNumber?: InputMaybe<Scalars['String']['input']>;
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  loanSubcategoryId?: InputMaybe<Scalars['Int']['input']>;
  loanType?: InputMaybe<Scalars['String']['input']>;
  nextPaymentDate?: InputMaybe<Scalars['String']['input']>;
  nonAccrualDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherFeeIndicator?: InputMaybe<Scalars['String']['input']>;
  otherFeesPaid?: InputMaybe<Scalars['Float']['input']>;
  paProcessedDate?: InputMaybe<Scalars['String']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  poolId?: InputMaybe<Scalars['ID']['input']>;
  poolNumber?: InputMaybe<Scalars['String']['input']>;
  principalPaid?: InputMaybe<Scalars['Float']['input']>;
  receivedDate: Scalars['String']['input'];
  recoveryAmount?: InputMaybe<Scalars['Float']['input']>;
  recoveryBalance?: InputMaybe<Scalars['Float']['input']>;
  recoveryDate?: InputMaybe<Scalars['String']['input']>;
  reportingPeriod: Scalars['String']['input'];
  scheduledPayment?: InputMaybe<Scalars['Float']['input']>;
};

export type Tokenservice_HealthCheckInput = {
  /** Run full JWT validator suite (all 16 tests). Default false runs lightweight test. */
  doFull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketplaceAgreementGateQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type MarketplaceAgreementGateQuery = { __typename?: 'Query', agreement_getMarketplaceGate: { __typename?: 'Agreement_MarketplaceGate', termsToAccept?: { __typename?: 'Agreement_Version', version: number, content: string } | null } };

export type AcceptMarketplaceTermsMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  version: Scalars['Int']['input'];
}>;


export type AcceptMarketplaceTermsMutation = { __typename?: 'Mutation', agreement_acceptTerms: { __typename?: 'Agreement_MarketplaceGate', termsToAccept?: { __typename?: 'Agreement_Version', version: number, content: string } | null } };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { __typename?: 'Query', user_getUserData?: { __typename?: 'User_UserData', institutionId?: number | null, firstName?: string | null, success: boolean, error?: string | null, portfolioData?: { __typename?: 'PortfolioData', id: number, activeDataDate?: string | null } | null } | null };

export type GetPoolsForBuyPageQueryVariables = Exact<{
  isActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPoolsForBuyPageQuery = { __typename?: 'Query', pools: Array<{ __typename?: 'Pool', id: string, poolName?: string | null, poolType?: PoolType | null, poolNumber: string, loanCount: number, balance: number, createdDate: string, servicingFeePercentage?: number | null, isRecourse: boolean, war?: number | null, warl?: number | null, waFico?: number | null, waLtv?: number | null, netYield?: number | null, grossYield?: number | null, isBookmarked: boolean, listing?: { __typename?: 'PoolListing', id: string, listingStage: PoolListingStage, listingStatus: PoolListingStatus, price: number, minBuyinType?: PoolListingBuyinType | null, minBuyinValue?: number | null, minBuyinAmount?: number | null, minBuyinPercentage?: number | null, listingDate?: string | null, settlementType?: SettlementType | null } | null, client?: { __typename?: 'Client', id: string, companyName?: string | null } | null, participants: Array<{ __typename?: 'PoolParticipant', id: string, buyerId: number, percentage: number, isSeller: boolean, buyer?: { __typename?: 'Client', companyName?: string | null } | null }> }> };

export type GetPoolForBuyPageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPoolForBuyPageQuery = { __typename?: 'Query', pool?: { __typename?: 'Pool', id: string, clientId?: number | null, loanPortfolioId?: number | null, poolName?: string | null, poolNumber: string, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, poolStatus?: PoolStatus | null, poolType?: PoolType | null, grossYield?: number | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, loanCount: number, balance: number, client?: { __typename?: 'Client', companyName?: string | null } | null, poolLoans: Array<{ __typename?: 'PoolLoan', id: string, poolId: string, loanId: string, clientId: number, poolLoanStatus: PoolLoanStatus, effectiveDate: string, endDate?: string | null, modifiedDate: string, originalSalesPrice?: number | null }>, participants: Array<{ __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, paysPlatformFee: boolean, effectiveDate: string, endDate?: string | null, isActive: boolean, isSeller: boolean, isServicer: boolean, modifiedDate: string, buyer?: { __typename?: 'Client', companyName?: string | null } | null }>, listing?: { __typename?: 'PoolListing', listingDate?: string | null, price: number, carveOutPermitted?: boolean | null, dueDiligencePeriod?: DueDiligencePeriod | null, dueDiligencePeriodDays?: number | null, recourseType?: RecourseType | null, settlementType?: SettlementType | null, servicingType?: ServicingType | null } | null } | null };

export type GetUserBuyFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBuyFiltersQuery = { __typename?: 'Query', getUserBuyFilters?: Array<{ __typename?: 'BuyFilterSet', id: number, filterName: string, filter: any, modifiedDate: any } | null> | null };

export type BookmarkPoolMutationVariables = Exact<{
  poolId: Scalars['Int']['input'];
}>;


export type BookmarkPoolMutation = { __typename?: 'Mutation', bookmarkPool: boolean };

export type UnbookmarkPoolMutationVariables = Exact<{
  poolId: Scalars['Int']['input'];
}>;


export type UnbookmarkPoolMutation = { __typename?: 'Mutation', unbookmarkPool: boolean };

export type SaveFilterSetMutationVariables = Exact<{
  input: CreateBuyFilterInput;
}>;


export type SaveFilterSetMutation = { __typename?: 'Mutation', createUserBuyFilter: { __typename?: 'BuyFilterSet', id: number, filterName: string } };

export type DeleteFilterSetMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFilterSetMutation = { __typename?: 'Mutation', deleteUserBuyFilter: boolean };

export type UpdateFilterSetMutationVariables = Exact<{
  input: UpdateBuyFilterInput;
}>;


export type UpdateFilterSetMutation = { __typename?: 'Mutation', updateUserBuyFilter: boolean };

export type CreatePoolBuyRequestMutationVariables = Exact<{
  input: CreatePoolBuyRequestInput;
}>;


export type CreatePoolBuyRequestMutation = { __typename?: 'Mutation', createPoolBuyRequest: { __typename?: 'PoolBuyRequest', id: number } };

export type InstitutionsPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type InstitutionsPageDataQuery = { __typename?: 'Query', getMarketplaceInstitutions: Array<{ __typename?: 'MarketplaceInstitution', id: number, name: string, institutionType: InstitutionType, cuNumber?: number | null, stateAbbrev?: string | null, totalAssets?: number | null, nameShort?: string | null }> };

export type FavoriteInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteInstitutionsQuery = { __typename?: 'Query', getFavoriteInstitutionIds: Array<number> };

export type AddFavoriteInstitutionMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type AddFavoriteInstitutionMutation = { __typename?: 'Mutation', addFavoriteInstitution: boolean };

export type RemoveFavoriteInstitutionMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type RemoveFavoriteInstitutionMutation = { __typename?: 'Mutation', removeFavoriteInstitution: boolean };

export type GetElementQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  elementType: Report_ElementType;
  elementSetting: Report_ElementSettingsInput;
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetElementQuery = { __typename?: 'Query', report_getElement?: { __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, truncated?: boolean | null, notes?: Array<string> | null, error?: Array<string | null> | null, numStrats?: number | null, debugSqlStrings?: Array<string | null> | null, chartData?: Array<string | null> | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null, children?: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null }> | null }>, rows?: Array<{ __typename?: 'Report_TableRow', rowClass?: string | null, cssId?: string | null, cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colClass?: string | null, hoverText?: string | null, colSpan?: number | null, rowSpan?: number | null, sortKey?: number | null, altSortKey?: number | null, children?: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colSpan?: number | null, rowSpan?: number | null } | null> | null }> }> | null } | null } | null };

export type GetManagePoolLoansQueryVariables = Exact<{
  poolId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetManagePoolLoansQuery = { __typename?: 'Query', poolLoans: Array<{ __typename?: 'PoolLoan', loan?: { __typename?: 'Loan', id: string, loanNumber?: string | null } | null }> };

export type GetPresetElementQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  elementSetting: Report_ElementSettingsInput;
  requestId: Scalars['String']['input'];
  dataLevel?: InputMaybe<Report_DataLevel>;
}>;


export type GetPresetElementQuery = { __typename?: 'Query', report_getPresetElement?: { __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, truncated?: boolean | null, notes?: Array<string> | null, error?: Array<string | null> | null, numStrats?: number | null, debugSqlStrings?: Array<string | null> | null, chartData?: Array<string | null> | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null, children?: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null }> | null }>, rows?: Array<{ __typename?: 'Report_TableRow', rowClass?: string | null, cssId?: string | null, cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colClass?: string | null, hoverText?: string | null, colSpan?: number | null, rowSpan?: number | null, sortKey?: number | null, altSortKey?: number | null, children?: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colSpan?: number | null, rowSpan?: number | null } | null> | null }> }> | null } | null } | null };

export type BatchGetPresetElementsQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  elementSetting: Report_ElementSettingsInput;
  requestIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  dataLevel?: InputMaybe<Report_DataLevel>;
}>;


export type BatchGetPresetElementsQuery = { __typename?: 'Query', report_batchGetPresetElements?: Array<{ __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, truncated?: boolean | null, notes?: Array<string> | null, error?: Array<string | null> | null, numStrats?: number | null, debugSqlStrings?: Array<string | null> | null, chartData?: Array<string | null> | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null, children?: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null }> | null }>, rows?: Array<{ __typename?: 'Report_TableRow', rowClass?: string | null, cssId?: string | null, cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colClass?: string | null, hoverText?: string | null, colSpan?: number | null, rowSpan?: number | null, sortKey?: number | null, altSortKey?: number | null, children?: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colSpan?: number | null, rowSpan?: number | null } | null> | null }> }> | null } | null } | null> | null };

export type ElementDataFragment = { __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, truncated?: boolean | null, notes?: Array<string> | null, error?: Array<string | null> | null, numStrats?: number | null, debugSqlStrings?: Array<string | null> | null, chartData?: Array<string | null> | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null, children?: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null }> | null }>, rows?: Array<{ __typename?: 'Report_TableRow', rowClass?: string | null, cssId?: string | null, cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colClass?: string | null, hoverText?: string | null, colSpan?: number | null, rowSpan?: number | null, sortKey?: number | null, altSortKey?: number | null, children?: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colSpan?: number | null, rowSpan?: number | null } | null> | null }> }> | null } | null };

export type GetPublicPresetElementQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  elementKey: Scalars['String']['input'];
  poolId: Scalars['ID']['input'];
}>;


export type GetPublicPresetElementQuery = { __typename?: 'Query', report_getPublicPresetElement?: { __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, truncated?: boolean | null, notes?: Array<string> | null, error?: Array<string | null> | null, numStrats?: number | null, debugSqlStrings?: Array<string | null> | null, chartData?: Array<string | null> | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null, children?: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null }> | null }>, rows?: Array<{ __typename?: 'Report_TableRow', rowClass?: string | null, cssId?: string | null, cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colClass?: string | null, hoverText?: string | null, colSpan?: number | null, rowSpan?: number | null, sortKey?: number | null, altSortKey?: number | null, children?: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colSpan?: number | null, rowSpan?: number | null } | null> | null }> }> | null } | null } | null };

export type BatchGetPublicPresetElementsQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  elementKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  poolId: Scalars['ID']['input'];
}>;


export type BatchGetPublicPresetElementsQuery = { __typename?: 'Query', report_batchGetPublicPresetElements?: Array<{ __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, truncated?: boolean | null, notes?: Array<string> | null, error?: Array<string | null> | null, numStrats?: number | null, debugSqlStrings?: Array<string | null> | null, chartData?: Array<string | null> | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null, children?: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, colSpan?: number | null, rowSpan?: number | null }> | null }>, rows?: Array<{ __typename?: 'Report_TableRow', rowClass?: string | null, cssId?: string | null, cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colClass?: string | null, hoverText?: string | null, colSpan?: number | null, rowSpan?: number | null, sortKey?: number | null, altSortKey?: number | null, children?: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null, href?: string | null, bold?: boolean | null, colSpan?: number | null, rowSpan?: number | null } | null> | null }> }> | null } | null } | null> | null };

export type SendTransactionsMutationVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  poolId: Scalars['Int']['input'];
}>;


export type SendTransactionsMutation = { __typename?: 'Mutation', sendTransactions: boolean };

export type GetAllPortfolioDataDatesQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllPortfolioDataDatesQuery = { __typename?: 'Query', user_getAllPortfolioDataDates?: { __typename?: 'User_AllPortfolioDataDates', dates?: Array<string | null> | null, error?: string | null, success: boolean } | null };

export type GetLoansForSavedGroupQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  elementType: Report_ElementType;
  elementSetting: Report_ElementSettingsInput;
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLoansForSavedGroupQuery = { __typename?: 'Query', report_getElement?: { __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, error?: Array<string | null> | null, truncated?: boolean | null, tableData?: { __typename?: 'Report_TableData', headers: Array<{ __typename?: 'Report_ColumnHeader', displayName: string, type?: Report_ColumnType | null, sortable?: boolean | null, fieldName?: string | null }>, rows?: Array<{ __typename?: 'Report_TableRow', cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null, valueType?: Report_ValueType | null }> }> | null } | null } | null };

export type GetLoanIdNumbersBySavedGroupQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  loanGroupId: Scalars['Int']['input'];
}>;


export type GetLoanIdNumbersBySavedGroupQuery = { __typename?: 'Query', report_getLoanIdNumbersBySavedGroup: { __typename?: 'Report_SavedGroupLoanIdNumbersResult', loanIdNumbers: Array<string> } };

export type GetSavedLoanGroupsQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
}>;


export type GetSavedLoanGroupsQuery = { __typename?: 'Query', report_getLoanGroups?: Array<{ __typename?: 'Report_ModuleRecordGroup', id?: number | null, name?: string | null, description?: string | null, recordCount?: number | null, createdByUsername?: string | null, createdByDate?: string | null, lastModifiedByUsername?: string | null, lastModifiedByDate?: string | null, shareStatus?: Report_ShareStatus | null } | null> | null };

export type GetInstitutionByCharterNumberQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  charterNumbers: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetInstitutionByCharterNumberQuery = { __typename?: 'Query', report_getInstitutionByCharterNumber?: Array<{ __typename?: 'Report_Institution', cuNumber?: number | null, institutionId?: number | null, cuName?: string | null, stateAbbrev?: string | null }> | null };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, companyName?: string | null, contactPerson?: string | null, contactEmail?: string | null, contactPhone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, pools: Array<{ __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null }>, loans: Array<{ __typename?: 'Loan', id: string, loanNumber?: string | null, paxLoanIdentifier?: string | null, originalBalance?: number | null, currentBalance?: number | null, interestRate?: number | null, originationDate?: string | null, maturityDate?: string | null, clientId?: number | null, loanStatus?: string | null, isActive?: boolean | null, createdDate?: string | null, modifiedDate?: string | null }> } | null };

export type GetClientsQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClientsQuery = { __typename?: 'Query', clients: Array<{ __typename?: 'Client', id: string, companyName?: string | null, contactPerson?: string | null, contactEmail?: string | null, contactPhone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, isActive: boolean, createdDate: string, modifiedDate?: string | null }> };

export type GetLoanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLoanQuery = { __typename?: 'Query', loan?: { __typename?: 'Loan', id: string, loanNumber?: string | null, paxLoanIdentifier?: string | null, originalBalance?: number | null, currentBalance?: number | null, interestRate?: number | null, originationDate?: string | null, maturityDate?: string | null, clientId?: number | null, loanStatus?: string | null, isActive?: boolean | null, createdDate?: string | null, modifiedDate?: string | null, client?: { __typename?: 'Client', id: string, companyName?: string | null, contactPerson?: string | null, contactEmail?: string | null, contactPhone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, isActive: boolean, createdDate: string, modifiedDate?: string | null } | null, poolLoans: Array<{ __typename?: 'PoolLoan', id: string, poolId: string, loanId: string, clientId: number, poolLoanStatus: PoolLoanStatus, effectiveDate: string, endDate?: string | null, modifiedDate: string, originalSalesPrice?: number | null }> } | null };

export type GetLoansQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']['input']>;
  loanStatus?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLoansQuery = { __typename?: 'Query', loans: Array<{ __typename?: 'Loan', id: string, loanNumber?: string | null, paxLoanIdentifier?: string | null, originalBalance?: number | null, currentBalance?: number | null, interestRate?: number | null, originationDate?: string | null, maturityDate?: string | null, clientId?: number | null, loanStatus?: string | null, isActive?: boolean | null, createdDate?: string | null, modifiedDate?: string | null }> };

export type GetPoolQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPoolQuery = { __typename?: 'Query', pool?: { __typename?: 'Pool', id: string, clientId?: number | null, loanPortfolioId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, netYield?: number | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, client?: { __typename?: 'Client', id: string, companyName?: string | null, contactPerson?: string | null, contactEmail?: string | null, contactPhone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, isActive: boolean, createdDate: string, modifiedDate?: string | null } | null, poolLoans: Array<{ __typename?: 'PoolLoan', id: string, poolId: string, loanId: string, clientId: number, poolLoanStatus: PoolLoanStatus, effectiveDate: string, endDate?: string | null, modifiedDate: string, originalSalesPrice?: number | null }>, participants: Array<{ __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, paysPlatformFee: boolean, effectiveDate: string, endDate?: string | null, isActive: boolean, isSeller: boolean, isServicer: boolean, modifiedDate: string, buyer?: { __typename?: 'Client', companyName?: string | null } | null }>, loans: Array<{ __typename?: 'Loan', id: string, loanNumber?: string | null, maturityDate?: string | null, originalBalance?: number | null, currentBalance?: number | null, isActive?: boolean | null }>, listing?: { __typename?: 'PoolListing', listingDate?: string | null, price: number, carveOutPermitted?: boolean | null, dueDiligencePeriod?: DueDiligencePeriod | null, dueDiligencePeriodDays?: number | null } | null } | null };

export type GetPoolWithStagingQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  reportingPeriod: Scalars['String']['input'];
}>;


export type GetPoolWithStagingQuery = { __typename?: 'Query', pool?: { __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, stagingSummary?: { __typename?: 'RemittanceStagingSummaryRow', reportingPeriod: string, clientId: number, poolId?: string | null, currentBalance?: number | null, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, chargeOffAmount?: number | null, recoveryAmount?: number | null, accruedInterest?: number | null, buybackAmount?: number | null } | null, remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> } | null };

export type GetPoolsQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']['input']>;
  isActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPoolsQuery = { __typename?: 'Query', pools: Array<{ __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, loanCount: number, participants: Array<{ __typename?: 'PoolParticipant', buyerId: number, isSeller: boolean, percentage: number, buyer?: { __typename?: 'Client', companyName?: string | null } | null }>, listing?: { __typename?: 'PoolListing', poolId: string, price: number, soldDate?: string | null } | null }> };

export type PoolsForBuyerQueryVariables = Exact<{
  buyerId: Scalars['Int']['input'];
}>;


export type PoolsForBuyerQuery = { __typename?: 'Query', poolParticipants: Array<{ __typename?: 'PoolParticipant', id: string, buyerId: number, percentage: number, isSeller: boolean, isServicer: boolean, pool?: { __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, loanCount: number, client?: { __typename?: 'Client', companyName?: string | null } | null, listing?: { __typename?: 'PoolListing', poolId: string, price: number, soldDate?: string | null } | null } | null }> };

export type GetPoolLoanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPoolLoanQuery = { __typename?: 'Query', poolLoan?: { __typename?: 'PoolLoan', id: string, poolId: string, loanId: string, clientId: number, poolLoanStatus: PoolLoanStatus, effectiveDate: string, endDate?: string | null, modifiedDate: string, originalSalesPrice?: number | null, pool?: { __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null } | null, loan?: { __typename?: 'Loan', id: string, loanNumber?: string | null, paxLoanIdentifier?: string | null, originalBalance?: number | null, currentBalance?: number | null, interestRate?: number | null, originationDate?: string | null, maturityDate?: string | null, clientId?: number | null, loanStatus?: string | null, isActive?: boolean | null, createdDate?: string | null, modifiedDate?: string | null } | null } | null };

export type GetPoolLoansQueryVariables = Exact<{
  poolId?: InputMaybe<Scalars['ID']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  poolLoanStatus?: InputMaybe<PoolLoanStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPoolLoansQuery = { __typename?: 'Query', poolLoans: Array<{ __typename?: 'PoolLoan', id: string, poolId: string, loanId: string, clientId: number, poolLoanStatus: PoolLoanStatus, effectiveDate: string, endDate?: string | null, modifiedDate: string, originalSalesPrice?: number | null }> };

export type UpsertLoansMutationVariables = Exact<{
  loans: Array<UpsertLoanInput> | UpsertLoanInput;
}>;


export type UpsertLoansMutation = { __typename?: 'Mutation', upsertLoans: Array<{ __typename?: 'Loan', id: string, loanNumber?: string | null, clientId?: number | null, currentBalance?: number | null, interestRate?: number | null, originationDate?: string | null, maturityDate?: string | null, loanStatus?: string | null, isActive?: boolean | null }> };

export type AddPoolLoansMutationVariables = Exact<{
  loans: Array<AddPoolLoanInput> | AddPoolLoanInput;
}>;


export type AddPoolLoansMutation = { __typename?: 'Mutation', addPoolLoans: Array<{ __typename?: 'PoolLoan', id: string, poolId: string, loanId: string, clientId: number, poolLoanStatus: PoolLoanStatus, effectiveDate: string, endDate?: string | null, modifiedDate: string, originalSalesPrice?: number | null }> };

export type LoanStatusForPoolByIdQueryVariables = Exact<{
  poolId: Scalars['ID']['input'];
  loanNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LoanStatusForPoolByIdQuery = { __typename?: 'Query', loanStatusForPool?: { __typename?: 'PoolLoanStatusResult', poolId: string, poolNumber: string, poolStatus?: PoolStatus | null, results: Array<{ __typename?: 'PoolLoanStatusEntry', loanNumber: string, loanId?: string | null, status: LoanLookupStatus, inPool: boolean }> } | null };

export type LoanStatusForPoolByNumberQueryVariables = Exact<{
  poolNumber: Scalars['String']['input'];
  loanNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type LoanStatusForPoolByNumberQuery = { __typename?: 'Query', loanStatusForPool?: { __typename?: 'PoolLoanStatusResult', poolId: string, poolNumber: string, poolStatus?: PoolStatus | null, results: Array<{ __typename?: 'PoolLoanStatusEntry', loanNumber: string, loanId?: string | null, status: LoanLookupStatus, inPool: boolean }> } | null };

export type GetPoolParticipantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPoolParticipantQuery = { __typename?: 'Query', poolParticipant?: { __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, paysPlatformFee: boolean, effectiveDate: string, endDate?: string | null, isActive: boolean, isSeller: boolean, isServicer: boolean, modifiedDate: string, pool?: { __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null } | null, buyer?: { __typename?: 'Client', id: string, companyName?: string | null, contactPerson?: string | null, contactEmail?: string | null, contactPhone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, isActive: boolean, createdDate: string, modifiedDate?: string | null } | null } | null };

export type GetPoolParticipantsQueryVariables = Exact<{
  poolId?: InputMaybe<Scalars['ID']['input']>;
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  isActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPoolParticipantsQuery = { __typename?: 'Query', poolParticipants: Array<{ __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, paysPlatformFee: boolean, effectiveDate: string, endDate?: string | null, isActive: boolean, isSeller: boolean, isServicer: boolean, modifiedDate: string }> };

export type GetRemittanceStagingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRemittanceStagingQuery = { __typename?: 'Query', remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type ListRemittanceStagingByPeriodQueryVariables = Exact<{
  reportingPeriod: Scalars['String']['input'];
  clientId: Scalars['Int']['input'];
}>;


export type ListRemittanceStagingByPeriodQuery = { __typename?: 'Query', remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type ListRemittanceStagingByPoolQueryVariables = Exact<{
  reportingPeriod: Scalars['String']['input'];
  poolNumber: Scalars['String']['input'];
}>;


export type ListRemittanceStagingByPoolQuery = { __typename?: 'Query', remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type ListRemittanceStagingByParticipantQueryVariables = Exact<{
  reportingPeriod: Scalars['String']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type ListRemittanceStagingByParticipantQuery = { __typename?: 'Query', remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type ListRemittanceStagingByLoanQueryVariables = Exact<{
  reportingPeriod: Scalars['String']['input'];
  loanNumber: Scalars['String']['input'];
  loanClientId: Scalars['Int']['input'];
}>;


export type ListRemittanceStagingByLoanQuery = { __typename?: 'Query', remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type ListRemittanceStagingByStatusQueryVariables = Exact<{
  reportingPeriod: Scalars['String']['input'];
  clientId: Scalars['Int']['input'];
  status: RemittanceStagingStatus;
}>;


export type ListRemittanceStagingByStatusQuery = { __typename?: 'Query', remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type GetRemittanceStagingSummaryQueryVariables = Exact<{
  reportingPeriod: Scalars['String']['input'];
  clientId: Scalars['Int']['input'];
  poolId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetRemittanceStagingSummaryQuery = { __typename?: 'Query', remittanceStagingSummary: Array<{ __typename?: 'RemittanceStagingSummaryRow', reportingPeriod: string, clientId: number, poolId?: string | null, currentBalance?: number | null, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, chargeOffAmount?: number | null, recoveryAmount?: number | null, accruedInterest?: number | null, buybackAmount?: number | null }> };

export type GetRemittanceStagingErrorsQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
  reportingPeriod: Scalars['String']['input'];
  poolId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetRemittanceStagingErrorsQuery = { __typename?: 'Query', remittanceStagingErrors: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, recoveryAmount?: number | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, batchId: string, status: RemittanceStagingStatus, processedDate?: string | null, createdDate: string, updatedDate?: string | null, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, recoveryDate?: string | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, errorCode?: string | null, errorMessage?: string | null, additionalFields?: string | null }> };

export type CreateRemittanceStagingMutationVariables = Exact<{
  input: CreateRemittanceStagingInput;
}>;


export type CreateRemittanceStagingMutation = { __typename?: 'Mutation', createRemittanceStaging: { __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, reportingPeriod: string, status: RemittanceStagingStatus, createdDate: string, updatedDate?: string | null } };

export type UpsertRemittanceStagingMutationVariables = Exact<{
  input: UpsertRemittanceStagingInput;
}>;


export type UpsertRemittanceStagingMutation = { __typename?: 'Mutation', upsertRemittanceStaging: boolean };

export type UpdateRemittanceStagingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRemittanceStagingInput;
}>;


export type UpdateRemittanceStagingMutation = { __typename?: 'Mutation', updateRemittanceStaging?: { __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, reportingPeriod: string, status: RemittanceStagingStatus, createdDate: string, updatedDate?: string | null } | null };

export type TransitionRemittanceStagingStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: RemittanceStagingStatus;
}>;


export type TransitionRemittanceStagingStatusMutation = { __typename?: 'Mutation', transitionRemittanceStagingStatus?: { __typename?: 'RemittanceStaging', id: string, status: RemittanceStagingStatus, updatedDate?: string | null } | null };

export type DeleteRemittanceStagingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRemittanceStagingMutation = { __typename?: 'Mutation', deleteRemittanceStaging: boolean };

export type GetClientWithRemittanceStagingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportingPeriod: Scalars['String']['input'];
}>;


export type GetClientWithRemittanceStagingQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, companyName?: string | null, contactPerson?: string | null, contactEmail?: string | null, contactPhone?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, reportingPeriod: string, status: RemittanceStagingStatus, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, currentBalance?: number | null, createdDate: string, updatedDate?: string | null }> } | null };

export type GetLoanWithRemittanceStagingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportingPeriod: Scalars['String']['input'];
}>;


export type GetLoanWithRemittanceStagingQuery = { __typename?: 'Query', loan?: { __typename?: 'Loan', id: string, loanNumber?: string | null, paxLoanIdentifier?: string | null, originalBalance?: number | null, currentBalance?: number | null, interestRate?: number | null, originationDate?: string | null, maturityDate?: string | null, clientId?: number | null, loanStatus?: string | null, isActive?: boolean | null, createdDate?: string | null, modifiedDate?: string | null, remittanceStaging: Array<{ __typename?: 'RemittanceStaging', id: string, clientId: number, poolId?: string | null, loanId?: string | null, reportingPeriod: string, status: RemittanceStagingStatus, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, currentBalance?: number | null, createdDate: string, updatedDate?: string | null }> } | null };

export type GetRemittanceHistoriesQueryVariables = Exact<{
  poolId?: InputMaybe<Scalars['ID']['input']>;
  reportingPeriod?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRemittanceHistoriesQuery = { __typename?: 'Query', remittanceHistories: Array<{ __typename?: 'RemittanceHistory', id: string, poolId: string, reportingPeriod: string, currentStep?: RemittanceStep | null, status: RemittanceStatus, createdAt: string, updatedAt: string }> };

export type GetRemittanceHistoriesByClientAndRoleQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<PoolRole>;
}>;


export type GetRemittanceHistoriesByClientAndRoleQuery = { __typename?: 'Query', remittanceHistories: Array<{ __typename?: 'RemittanceHistory', id: string, poolId: string, reportingPeriod: string, status: RemittanceStatus, currentStep?: RemittanceStep | null, pool?: { __typename?: 'Pool', id: string, clientId?: number | null, poolNumber: string, poolName?: string | null, description?: string | null, servicingFeePercentage?: number | null, platformFeePercentage?: number | null, effectiveDate?: string | null, endDate?: string | null, isRecourse: boolean, poolStatus?: PoolStatus | null, poolType?: PoolType | null, isActive: boolean, createdDate: string, modifiedDate?: string | null, loanCount: number, client?: { __typename?: 'Client', companyName?: string | null } | null, participants: Array<{ __typename?: 'PoolParticipant', buyerId: number, isSeller: boolean, percentage: number, buyer?: { __typename?: 'Client', companyName?: string | null } | null }>, listing?: { __typename?: 'PoolListing', poolId: string, price: number, soldDate?: string | null } | null } | null }> };

export type CreateRemittanceHistoryMutationVariables = Exact<{
  input: CreateRemittanceHistoryInput;
}>;


export type CreateRemittanceHistoryMutation = { __typename?: 'Mutation', createRemittanceHistory: { __typename?: 'RemittanceHistory', id: string, poolId: string, reportingPeriod: string, currentStep?: RemittanceStep | null, status: RemittanceStatus, createdAt: string, updatedAt: string } };

export type UpdateRemittanceHistoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRemittanceHistoryInput;
}>;


export type UpdateRemittanceHistoryMutation = { __typename?: 'Mutation', updateRemittanceHistory?: { __typename?: 'RemittanceHistory', id: string, poolId: string, reportingPeriod: string, currentStep?: RemittanceStep | null, status: RemittanceStatus, updatedAt: string } | null };

export type GenerateRemittanceMutationVariables = Exact<{
  poolId: Scalars['Int']['input'];
}>;


export type GenerateRemittanceMutation = { __typename?: 'Mutation', generateRemittance: { __typename?: 'GenerateRemittanceResult', stagingProcessed: number } };

export type GetPreviewPoolRemittanceSummaryQueryVariables = Exact<{
  poolId: Scalars['Int']['input'];
  participantClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPreviewPoolRemittanceSummaryQuery = { __typename?: 'Query', previewPoolRemittanceSummary: Array<{ __typename?: 'RemittancePreviewSummaryRow', buyerId: number, reportingPeriod: string, loanCount: number, currentBalance: number, paymentAmount: number, principalPaid: number, interestPaid: number, lateFeesPaid: number, otherFeesPaid: number, chargeOffAmount: number, chargeOffBalance: number, recoveryAmount: number, recoveryBalance: number, accruedInterest: number, buybackAmount: number, servicingFee: number, platformFee: number, scheduledPayment: number, creditLimit: number, amountPastDue: number, loanLevelServiceFee: number, cpiInsRefund: number }> };

export type GetPreviewPoolGlSummaryQueryVariables = Exact<{
  poolId: Scalars['Int']['input'];
  participantClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPreviewPoolGlSummaryQuery = { __typename?: 'Query', previewPoolGlSummary: Array<{ __typename?: 'GlPreviewSummaryRow', clientId: number, totalDebits: number, totalCredits: number, netAmount: number, transactionCount: number }> };

export type GetPreviewPoolRemittanceQueryVariables = Exact<{
  poolId: Scalars['Int']['input'];
  participantClientId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPreviewPoolRemittanceQuery = { __typename?: 'Query', previewPoolRemittance: { __typename?: 'PoolRemittancePreview', remittanceRows: Array<{ __typename?: 'RemittancePreviewRow', clientId: number, poolId?: string | null, loanId?: string | null, loanNumber?: string | null, buyerId: number, reportingPeriod: string, effectiveDate: string, receivedDate: string, currentBalance?: number | null, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, accruedInterest?: number | null, servicingFee?: number | null, platformFee?: number | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, nextPaymentDate?: string | null, daysPastDue?: number | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, chargeOffBalance?: number | null, chargeOffType?: string | null, recoveryAmount?: number | null, recoveryDate?: string | null, recoveryBalance?: number | null, isTdr?: boolean | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, isBankruptcy?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, isFrozen?: boolean | null, isReversal?: boolean | null, delinquentEver?: boolean | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, interestRate?: number | null }>, glRows: Array<{ __typename?: 'GeneralLedgerPreviewRow', poolId?: string | null, clientId?: number | null, amount: number, transactionDate: string, effectiveDate: string, postingDate?: string | null, accountId?: number | null, debitCredit: DebitCredit, transactionTypeId: number, transactionStatusId: number, reversalReferenceId?: string | null, description?: string | null, referenceNumber?: string | null }> } };

export type GetRemittancesQueryVariables = Exact<{
  poolId?: InputMaybe<Scalars['ID']['input']>;
  reportingPeriod?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRemittancesQuery = { __typename?: 'Query', remittances: Array<{ __typename?: 'Remittance', id: string, clientId: number, poolId?: string | null, loanId?: string | null, coreLoanId?: string | null, buyerId: number, sourceFileName?: string | null, reportingPeriod: string, receivedDate: string, effectiveDate: string, paymentAmount?: number | null, principalPaid?: number | null, interestPaid?: number | null, lateFeesPaid?: number | null, otherFeesPaid?: number | null, nextPaymentDate?: string | null, chargeOffAmount?: number | null, chargeOffDate?: string | null, chargeOffBalance?: number | null, recoveryAmount?: number | null, recoveryDate?: string | null, isTdr?: boolean | null, bankruptcyChapter?: number | null, bankruptcyDate?: string | null, daysPastDue?: number | null, isNonAccrual?: boolean | null, nonAccrualDate?: string | null, currentBalance?: number | null, accruedInterest?: number | null, currentInterestRate?: number | null, servicingFee?: number | null, platformFee?: number | null, batchId?: string | null, createdDate: string, loanNumber?: string | null, loanStatus?: string | null, scheduledPayment?: number | null, creditLimit?: number | null, loanType?: string | null, loanSubcategoryId?: number | null, amountPastDue?: number | null, lastPaymentDate?: string | null, chargeOffType?: string | null, buybackAmount?: number | null, recoveryBalance?: number | null, loanLevelServiceFee?: number | null, cpiInsRefund?: number | null, otherFeeIndicator?: string | null, delinquentEver?: boolean | null, isBankruptcy?: boolean | null, isFrozen?: boolean | null, isReversal?: boolean | null, paProcessedDate?: string | null, filename?: string | null, interestRate?: number | null }> };

export type InsertBuyersIfNotExistsMutationVariables = Exact<{
  clients: Array<CreateClientInput> | CreateClientInput;
}>;


export type InsertBuyersIfNotExistsMutation = { __typename?: 'Mutation', insertClientsIfNotExists: Array<{ __typename?: 'Client', id: string, companyName?: string | null, contactEmail?: string | null, state?: string | null, createdDate: string, modifiedDate?: string | null } | null> };

export type MyPortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfoliosQuery = { __typename?: 'Query', getMyPortfolios: { __typename?: 'MyPortfoliosResult', isAllAccess: boolean, institutions: Array<{ __typename?: 'Institution', id: number, instName: string, nameShort?: string | null, primaryLoanPortfolioId?: number | null, activeDataDate?: string | null }> } };

export type GetDraftPoolLoansQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  elementType: Report_ElementType;
  elementSetting: Report_ElementSettingsInput;
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDraftPoolLoansQuery = { __typename?: 'Query', report_getElement?: { __typename?: 'Report_ElementData', requestId: string, status: Report_ElementStatus, error?: Array<string | null> | null, truncated?: boolean | null, tableData?: { __typename?: 'Report_TableData', rows?: Array<{ __typename?: 'Report_TableRow', cells: Array<{ __typename?: 'Report_TableCell', value?: string | null, displayValue?: string | null }> }> | null } | null } | null };

export type GetReportTabStructureConfigQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
}>;


export type GetReportTabStructureConfigQuery = { __typename?: 'Query', report_getTabStructureConfigs?: { __typename?: 'Report_AllTabConfigs', filters?: { __typename?: 'Report_FilterTabConfigs', active?: { __typename?: 'TabStructureConfig', fields?: Array<Array<Array<{ __typename?: 'TabStructureField', name?: string | null } | null> | null> | null> | null } | null } | null } | null };

export type GetRandomLoansByTargetValueQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
  elementSetting: Report_ElementSettingsInput;
  targetValue: Scalars['Float']['input'];
  tolerancePct: Scalars['Float']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRandomLoansByTargetValueQuery = { __typename?: 'Query', report_getRandomLoansByTargetValue: { __typename?: 'Report_RandomLoansResult', loanIdNumbers: Array<string>, achievedTotal: number, requestedTotal: number, reachedTarget: boolean, truncated: boolean } };

export type GetLoanTypeDescriptionQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
}>;


export type GetLoanTypeDescriptionQuery = { __typename?: 'Query', getLoanTypes: Array<{ __typename?: 'LoanType', loanCategory: string, loanSubCategory?: Array<{ __typename?: 'SubCategoryDescriptions', loanSubCategory: string, descriptions?: Array<string | null> | null } | null> | null }> };

export type GeneratePoolNumberAndNameMutationVariables = Exact<{
  input: GeneratePoolNumberAndNameInput;
}>;


export type GeneratePoolNumberAndNameMutation = { __typename?: 'Mutation', generatePoolNumberAndName: { __typename?: 'GeneratePoolNumberAndNameResult', poolNumber: string, poolName: string } };

export type CreatePoolMutationVariables = Exact<{
  input: CreatePoolInput;
}>;


export type CreatePoolMutation = { __typename?: 'Mutation', createPool: { __typename?: 'Pool', id: string, poolNumber: string, poolName?: string | null, poolType?: PoolType | null, poolStatus?: PoolStatus | null, isActive: boolean, createdDate: string } };

export type CreatePoolFromFilterMutationVariables = Exact<{
  input: CreatePoolFromFilterInput;
}>;


export type CreatePoolFromFilterMutation = { __typename?: 'Mutation', createPoolFromFilter: { __typename?: 'Pool', id: string, poolNumber: string, poolName?: string | null, poolType?: PoolType | null, poolStatus?: PoolStatus | null, isActive: boolean, createdDate: string } };

export type CreatePoolListingMutationVariables = Exact<{
  input: CreatePoolListingInput;
}>;


export type CreatePoolListingMutation = { __typename?: 'Mutation', createPoolListing: { __typename?: 'PoolListing', id: string, poolId: string, price: number, listingStage: PoolListingStage, listingStatus: PoolListingStatus, isActive: boolean, createdDate: string } };

export type UpdatePoolMetricsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdatePoolMetricsInput;
}>;


export type UpdatePoolMetricsMutation = { __typename?: 'Mutation', updatePoolMetrics: { __typename?: 'Pool', id: string, war?: number | null, netYield?: number | null, waFico?: number | null, waLtv?: number | null, warl?: number | null, poolName?: string | null, loanCount: number } };

export type AddLoansToPoolFromFilterMutationVariables = Exact<{
  input: AddLoansToPoolFromFilterInput;
}>;


export type AddLoansToPoolFromFilterMutation = { __typename?: 'Mutation', addLoansToPoolFromFilter: { __typename?: 'Pool', id: string, poolName?: string | null, loanCount: number } };

export type CheckExistingPoolParticipantQueryVariables = Exact<{
  poolId: Scalars['ID']['input'];
  buyerId: Scalars['Int']['input'];
}>;


export type CheckExistingPoolParticipantQuery = { __typename?: 'Query', poolParticipants: Array<{ __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, isSeller: boolean, isServicer: boolean }> };

export type UpdatePoolListingMutationVariables = Exact<{
  poolId: Scalars['ID']['input'];
  input: UpdatePoolListingInput;
}>;


export type UpdatePoolListingMutation = { __typename?: 'Mutation', updatePoolListing?: { __typename?: 'PoolListing', id: string, poolId: string, price: number, minBuyinType?: PoolListingBuyinType | null, minBuyinValue?: number | null, listingType?: PoolListingType | null, institutionNameDisclosure?: InstitutionNameDisclosure | null, dueDiligencePeriod?: DueDiligencePeriod | null, dueDiligencePeriodDays?: number | null, carveOutPermitted?: boolean | null, recourseType?: RecourseType | null, listingStage: PoolListingStage, listingStatus: PoolListingStatus } | null };

export type UpdatePoolServicingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdatePoolInput;
}>;


export type UpdatePoolServicingMutation = { __typename?: 'Mutation', updatePool: { __typename?: 'Pool', id: string, servicingFeePercentage?: number | null } };

export type CreatePoolParticipantMutationVariables = Exact<{
  input: CreatePoolParticipantInput;
}>;


export type CreatePoolParticipantMutation = { __typename?: 'Mutation', createPoolParticipant: { __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, isSeller: boolean, isServicer: boolean } };

export type UpdatePoolParticipantMutationVariables = Exact<{
  poolId: Scalars['ID']['input'];
  buyerId: Scalars['Int']['input'];
  input: UpdatePoolParticipantInput;
}>;


export type UpdatePoolParticipantMutation = { __typename?: 'Mutation', updatePoolParticipantByPoolByBuyer?: { __typename?: 'PoolParticipant', id: string, poolId: string, buyerId: number, percentage: number, isSeller: boolean } | null };

export type GetMarketplaceLoansQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMarketplaceLoansQuery = { __typename?: 'Query', loans: Array<{ __typename?: 'Loan', id: string, loanNumber?: string | null, originationDate?: string | null, currentBalance?: number | null, interestRate?: number | null }> };

export type GetPoolsForSellPageQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['Int']['input']>;
  isActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPoolsForSellPageQuery = { __typename?: 'Query', pools: Array<{ __typename?: 'Pool', id: string, poolNumber: string, poolName?: string | null, poolType?: PoolType | null, loanCount: number, balance: number, createdDate: string, loanPortfolioId?: number | null, listing?: { __typename?: 'PoolListing', id: string, listingStage: PoolListingStage, isActive: boolean, price: number } | null }> };

export type GetPoolForSellEditQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPoolForSellEditQuery = { __typename?: 'Query', pool?: { __typename?: 'Pool', id: string, loans: Array<{ __typename?: 'Loan', id: string, loanNumber?: string | null }>, poolLoans: Array<{ __typename?: 'PoolLoan', id: string, loanId: string }> } | null };

export type GetPoolForSellPageQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPoolForSellPageQuery = { __typename?: 'Query', pool?: { __typename?: 'Pool', id: string, poolName?: string | null, createdDate: string, loanCount: number, grossYield?: number | null, poolType?: PoolType | null, servicingFeePercentage?: number | null, listing?: { __typename?: 'PoolListing', listingStage: PoolListingStage, settlementType?: SettlementType | null, recourseType?: RecourseType | null, price: number, dueDiligencePeriod?: DueDiligencePeriod | null, dueDiligencePeriodDays?: number | null, carveOutPermitted?: boolean | null, servicingType?: ServicingType | null } | null, loans: Array<{ __typename?: 'Loan', currentBalance?: number | null, id: string, loanNumber?: string | null }>, participants: Array<{ __typename?: 'PoolParticipant', isSeller: boolean, percentage: number }> } | null };

export type DeletePoolLoanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePoolLoanMutation = { __typename?: 'Mutation', deletePoolLoan: boolean };

export type UpdatePoolMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: UpdatePoolInput;
}>;


export type UpdatePoolMutation = { __typename?: 'Mutation', updatePool: { __typename?: 'Pool', id: string, poolName?: string | null, poolType?: PoolType | null, loanCount: number, createdDate: string, listing?: { __typename?: 'PoolListing', id: string, listingStage: PoolListingStage } | null } };

export type BrowsePoolBuyRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrowsePoolBuyRequestsQuery = { __typename?: 'Query', browsePoolBuyRequests: Array<{ __typename?: 'BrowsablePoolBuyRequest', id: number, assetClass: PoolType, poolSizeMin?: any | null, poolSizeMax?: any | null, description?: string | null, targetYield?: any | null, createdDate: any, hasInquired: boolean, status: PoolBuyRequestStatus }> };

export type CreatePoolBuyRequestInquiryMutationVariables = Exact<{
  input: CreatePoolBuyRequestInquiryInput;
}>;


export type CreatePoolBuyRequestInquiryMutation = { __typename?: 'Mutation', createPoolBuyRequestInquiry: { __typename?: 'PoolBuyRequestInquiry', poolBuyRequestId: number } };

export type AgreementVersionFieldsFragment = { __typename?: 'Agreement_Version', version: number, content: string, requiredAcceptance: boolean, publishedAt: string, publishedByUserId: number, publishedByUsername: string, publishedByName: string };

export type AgreementVersionHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type AgreementVersionHistoryQuery = { __typename?: 'Query', agreement_getVersionHistory: Array<{ __typename?: 'Agreement_Version', version: number, content: string, requiredAcceptance: boolean, publishedAt: string, publishedByUserId: number, publishedByUsername: string, publishedByName: string }> };

export type PublishTermsVersionMutationVariables = Exact<{
  input: Agreement_PublishVersionInput;
}>;


export type PublishTermsVersionMutation = { __typename?: 'Mutation', agreement_publishVersion: { __typename?: 'Agreement_Version', version: number, content: string, requiredAcceptance: boolean, publishedAt: string, publishedByUserId: number, publishedByUsername: string, publishedByName: string } };

export type AgreementAcceptanceRecordFieldsFragment = { __typename?: 'Agreement_AcceptanceRecord', institutionId: number, institutionName: string, acceptedByUserId: number, acceptedByUsername: string, acceptedByName: string, version: number, acceptedAt: string, ipAddress?: string | null, userAgent?: string | null };

export type AgreementExportAcceptancesQueryVariables = Exact<{
  input: Agreement_ExportAcceptancesInput;
}>;


export type AgreementExportAcceptancesQuery = { __typename?: 'Query', agreement_exportAcceptances: Array<{ __typename?: 'Agreement_AcceptanceRecord', institutionId: number, institutionName: string, acceptedByUserId: number, acceptedByUsername: string, acceptedByName: string, version: number, acceptedAt: string, ipAddress?: string | null, userAgent?: string | null }> };

export type InstitutionMemberMarketplaceRightsQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type InstitutionMemberMarketplaceRightsQuery = { __typename?: 'Query', getInstitutionMemberRights?: Array<{ __typename?: 'InstitutionMember', id: number, firstName?: string | null, lastName?: string | null, username: string, marketplaceRights?: { __typename?: 'MarketplaceRights', basicAccess: boolean, initiateInterest: boolean, approveInterest: boolean, publishListing: boolean, reconcileData: boolean, approveRemittance: boolean, importSavedGroupAsPool: boolean, mpAdminAccess?: MpAdminAccess | null } | null }> | null };

export type AddLeadershipMemberMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  member: LeadershipMemberInput;
}>;


export type AddLeadershipMemberMutation = { __typename?: 'Mutation', addLeadershipMember: { __typename?: 'LeadershipMember', id: number, firstName: string, lastName: string, title: string, startDate: string } };

export type UpdateLeadershipMemberMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  member: LeadershipMemberInput;
}>;


export type UpdateLeadershipMemberMutation = { __typename?: 'Mutation', updateLeadershipMember: { __typename?: 'LeadershipMember', id: number, firstName: string, lastName: string, title: string, startDate: string } };

export type ReorderLeadershipMembersMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  memberOrder: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ReorderLeadershipMembersMutation = { __typename?: 'Mutation', reorderLeadershipMembers: Array<{ __typename?: 'LeadershipMember', firstName: string, lastName: string, title: string, startDate: string }> };

export type DeleteLeadershipMemberMutationVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
}>;


export type DeleteLeadershipMemberMutation = { __typename?: 'Mutation', deleteLeadershipMember: boolean };

export type GetInstitutionSignatureStatusQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type GetInstitutionSignatureStatusQuery = { __typename?: 'Query', SignatureService_getInstitutionSignatureStatus: { __typename?: 'SignatureService_InstitutionSignatureStatus', institutionId: number, signed: boolean, signatureRecord?: { __typename?: 'SignatureService_SignatureRecord', workflowId: string, status: string, completedAt?: string | null } | null } };

export type GetInstitutionProfileQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type GetInstitutionProfileQuery = { __typename?: 'Query', getMarketplaceInstitution?: { __typename?: 'MarketplaceInstitution', name: string, address?: string | null, city?: string | null, stateAbbrev?: string | null, zipCode?: string | null } | null };

export type InstitutionQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type InstitutionQuery = { __typename?: 'Query', getMarketplaceInstitution?: { __typename?: 'MarketplaceInstitution', name: string, institutionType: InstitutionType, cuNumber?: number | null, city?: string | null, stateAbbrev?: string | null, url?: string | null, leadership?: Array<{ __typename?: 'LeadershipMember', id: number, firstName: string, lastName: string, title: string, startDate: string }> | null } | null };

export type InstitutionLeadershipQueryVariables = Exact<{
  institutionId: Scalars['Int']['input'];
}>;


export type InstitutionLeadershipQuery = { __typename?: 'Query', getInstitutionLeadership?: Array<{ __typename?: 'LeadershipMember', id: number, firstName: string, lastName: string, title: string, startDate: string }> | null };


export const ElementDataFragmentDoc = `
    fragment elementData on Report_ElementData {
  requestId
  status
  truncated
  notes
  error
  numStrats
  debugSqlStrings
  chartData
  tableData {
    headers {
      displayName
      type
      sortable
      colSpan
      rowSpan
      children {
        displayName
        type
        sortable
        colSpan
        rowSpan
      }
    }
    rows {
      rowClass
      cssId
      cells {
        value
        displayValue
        valueType
        href
        bold
        colClass
        hoverText
        colSpan
        rowSpan
        sortKey
        altSortKey
        children {
          value
          displayValue
          valueType
          href
          bold
          colSpan
          rowSpan
        }
      }
    }
  }
}
    `;
export const AgreementVersionFieldsFragmentDoc = `
    fragment AgreementVersionFields on Agreement_Version {
  version
  content
  requiredAcceptance
  publishedAt
  publishedByUserId
  publishedByUsername
  publishedByName
}
    `;
export const AgreementAcceptanceRecordFieldsFragmentDoc = `
    fragment AgreementAcceptanceRecordFields on Agreement_AcceptanceRecord {
  institutionId
  institutionName
  acceptedByUserId
  acceptedByUsername
  acceptedByName
  version
  acceptedAt
  ipAddress
  userAgent
}
    `;
export const MarketplaceAgreementGateDocument = `
    query marketplaceAgreementGate($institutionId: Int!) {
  agreement_getMarketplaceGate(institutionId: $institutionId) {
    termsToAccept {
      version
      content
    }
  }
}
    `;

export const useMarketplaceAgreementGateQuery = <
      TData = MarketplaceAgreementGateQuery,
      TError = unknown
    >(
      variables: MarketplaceAgreementGateQueryVariables,
      options?: Omit<UseQueryOptions<MarketplaceAgreementGateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MarketplaceAgreementGateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MarketplaceAgreementGateQuery, TError, TData>(
      {
    queryKey: ['marketplaceAgreementGate', variables],
    queryFn: useFetchData<MarketplaceAgreementGateQuery, MarketplaceAgreementGateQueryVariables>(MarketplaceAgreementGateDocument).bind(null, variables),
    ...options
  }
    )};

useMarketplaceAgreementGateQuery.getKey = (variables: MarketplaceAgreementGateQueryVariables) => ['marketplaceAgreementGate', variables];

export const AcceptMarketplaceTermsDocument = `
    mutation acceptMarketplaceTerms($institutionId: Int!, $version: Int!) {
  agreement_acceptTerms(institutionId: $institutionId, version: $version) {
    termsToAccept {
      version
      content
    }
  }
}
    `;

export const useAcceptMarketplaceTermsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptMarketplaceTermsMutation, TError, AcceptMarketplaceTermsMutationVariables, TContext>) => {
    
    return useMutation<AcceptMarketplaceTermsMutation, TError, AcceptMarketplaceTermsMutationVariables, TContext>(
      {
    mutationKey: ['acceptMarketplaceTerms'],
    mutationFn: useFetchData<AcceptMarketplaceTermsMutation, AcceptMarketplaceTermsMutationVariables>(AcceptMarketplaceTermsDocument),
    ...options
  }
    )};

useAcceptMarketplaceTermsMutation.getKey = () => ['acceptMarketplaceTerms'];

export const UserDataDocument = `
    query userData {
  user_getUserData {
    institutionId
    firstName
    success
    error
    portfolioData {
      id
      activeDataDate
    }
  }
}
    `;

export const useUserDataQuery = <
      TData = UserDataQuery,
      TError = unknown
    >(
      variables?: UserDataQueryVariables,
      options?: Omit<UseQueryOptions<UserDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userData'] : ['userData', variables],
    queryFn: useFetchData<UserDataQuery, UserDataQueryVariables>(UserDataDocument).bind(null, variables),
    ...options
  }
    )};

useUserDataQuery.getKey = (variables?: UserDataQueryVariables) => variables === undefined ? ['userData'] : ['userData', variables];

export const GetPoolsForBuyPageDocument = `
    query GetPoolsForBuyPage($isActiveOnly: Boolean) {
  pools(isActiveOnly: $isActiveOnly, tier: MARKET) {
    id
    poolName
    poolType
    poolNumber
    loanCount
    balance
    createdDate
    servicingFeePercentage
    isRecourse
    war
    warl
    waFico
    waLtv
    netYield
    grossYield
    listing {
      id
      listingStage
      listingStatus
      price
      minBuyinType
      minBuyinValue
      minBuyinAmount
      minBuyinPercentage
      listingDate
      settlementType
    }
    client {
      id
      companyName
    }
    participants {
      id
      buyerId
      percentage
      isSeller
      buyer {
        companyName
      }
    }
    isBookmarked
  }
}
    `;

export const useGetPoolsForBuyPageQuery = <
      TData = GetPoolsForBuyPageQuery,
      TError = unknown
    >(
      variables?: GetPoolsForBuyPageQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolsForBuyPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolsForBuyPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolsForBuyPageQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPoolsForBuyPage'] : ['GetPoolsForBuyPage', variables],
    queryFn: useFetchData<GetPoolsForBuyPageQuery, GetPoolsForBuyPageQueryVariables>(GetPoolsForBuyPageDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolsForBuyPageQuery.getKey = (variables?: GetPoolsForBuyPageQueryVariables) => variables === undefined ? ['GetPoolsForBuyPage'] : ['GetPoolsForBuyPage', variables];

export const GetPoolForBuyPageDocument = `
    query GetPoolForBuyPage($id: Int!) {
  pool(id: $id) {
    id
    clientId
    loanPortfolioId
    poolName
    poolNumber
    description
    servicingFeePercentage
    platformFeePercentage
    effectiveDate
    endDate
    poolStatus
    poolType
    grossYield
    isActive
    createdDate
    modifiedDate
    loanCount
    balance
    client {
      companyName
    }
    poolLoans {
      id
      poolId
      loanId
      clientId
      poolLoanStatus
      effectiveDate
      endDate
      modifiedDate
      originalSalesPrice
    }
    participants {
      id
      poolId
      buyerId
      percentage
      buyer {
        companyName
      }
      paysPlatformFee
      effectiveDate
      endDate
      isActive
      isSeller
      isServicer
      modifiedDate
    }
    listing {
      listingDate
      price
      carveOutPermitted
      dueDiligencePeriod
      dueDiligencePeriodDays
      recourseType
      settlementType
      servicingType
    }
  }
}
    `;

export const useGetPoolForBuyPageQuery = <
      TData = GetPoolForBuyPageQuery,
      TError = unknown
    >(
      variables: GetPoolForBuyPageQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolForBuyPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolForBuyPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolForBuyPageQuery, TError, TData>(
      {
    queryKey: ['GetPoolForBuyPage', variables],
    queryFn: useFetchData<GetPoolForBuyPageQuery, GetPoolForBuyPageQueryVariables>(GetPoolForBuyPageDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolForBuyPageQuery.getKey = (variables: GetPoolForBuyPageQueryVariables) => ['GetPoolForBuyPage', variables];

export const GetUserBuyFiltersDocument = `
    query GetUserBuyFilters {
  getUserBuyFilters {
    id
    filterName
    filter
    modifiedDate
  }
}
    `;

export const useGetUserBuyFiltersQuery = <
      TData = GetUserBuyFiltersQuery,
      TError = unknown
    >(
      variables?: GetUserBuyFiltersQueryVariables,
      options?: Omit<UseQueryOptions<GetUserBuyFiltersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserBuyFiltersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserBuyFiltersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserBuyFilters'] : ['GetUserBuyFilters', variables],
    queryFn: useFetchData<GetUserBuyFiltersQuery, GetUserBuyFiltersQueryVariables>(GetUserBuyFiltersDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserBuyFiltersQuery.getKey = (variables?: GetUserBuyFiltersQueryVariables) => variables === undefined ? ['GetUserBuyFilters'] : ['GetUserBuyFilters', variables];

export const BookmarkPoolDocument = `
    mutation bookmarkPool($poolId: Int!) {
  bookmarkPool(poolId: $poolId)
}
    `;

export const useBookmarkPoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BookmarkPoolMutation, TError, BookmarkPoolMutationVariables, TContext>) => {
    
    return useMutation<BookmarkPoolMutation, TError, BookmarkPoolMutationVariables, TContext>(
      {
    mutationKey: ['bookmarkPool'],
    mutationFn: useFetchData<BookmarkPoolMutation, BookmarkPoolMutationVariables>(BookmarkPoolDocument),
    ...options
  }
    )};

useBookmarkPoolMutation.getKey = () => ['bookmarkPool'];

export const UnbookmarkPoolDocument = `
    mutation unbookmarkPool($poolId: Int!) {
  unbookmarkPool(poolId: $poolId)
}
    `;

export const useUnbookmarkPoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnbookmarkPoolMutation, TError, UnbookmarkPoolMutationVariables, TContext>) => {
    
    return useMutation<UnbookmarkPoolMutation, TError, UnbookmarkPoolMutationVariables, TContext>(
      {
    mutationKey: ['unbookmarkPool'],
    mutationFn: useFetchData<UnbookmarkPoolMutation, UnbookmarkPoolMutationVariables>(UnbookmarkPoolDocument),
    ...options
  }
    )};

useUnbookmarkPoolMutation.getKey = () => ['unbookmarkPool'];

export const SaveFilterSetDocument = `
    mutation saveFilterSet($input: CreateBuyFilterInput!) {
  createUserBuyFilter(input: $input) {
    id
    filterName
  }
}
    `;

export const useSaveFilterSetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveFilterSetMutation, TError, SaveFilterSetMutationVariables, TContext>) => {
    
    return useMutation<SaveFilterSetMutation, TError, SaveFilterSetMutationVariables, TContext>(
      {
    mutationKey: ['saveFilterSet'],
    mutationFn: useFetchData<SaveFilterSetMutation, SaveFilterSetMutationVariables>(SaveFilterSetDocument),
    ...options
  }
    )};

useSaveFilterSetMutation.getKey = () => ['saveFilterSet'];

export const DeleteFilterSetDocument = `
    mutation deleteFilterSet($id: Int!) {
  deleteUserBuyFilter(id: $id)
}
    `;

export const useDeleteFilterSetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFilterSetMutation, TError, DeleteFilterSetMutationVariables, TContext>) => {
    
    return useMutation<DeleteFilterSetMutation, TError, DeleteFilterSetMutationVariables, TContext>(
      {
    mutationKey: ['deleteFilterSet'],
    mutationFn: useFetchData<DeleteFilterSetMutation, DeleteFilterSetMutationVariables>(DeleteFilterSetDocument),
    ...options
  }
    )};

useDeleteFilterSetMutation.getKey = () => ['deleteFilterSet'];

export const UpdateFilterSetDocument = `
    mutation updateFilterSet($input: UpdateBuyFilterInput!) {
  updateUserBuyFilter(input: $input)
}
    `;

export const useUpdateFilterSetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFilterSetMutation, TError, UpdateFilterSetMutationVariables, TContext>) => {
    
    return useMutation<UpdateFilterSetMutation, TError, UpdateFilterSetMutationVariables, TContext>(
      {
    mutationKey: ['updateFilterSet'],
    mutationFn: useFetchData<UpdateFilterSetMutation, UpdateFilterSetMutationVariables>(UpdateFilterSetDocument),
    ...options
  }
    )};

useUpdateFilterSetMutation.getKey = () => ['updateFilterSet'];

export const CreatePoolBuyRequestDocument = `
    mutation createPoolBuyRequest($input: CreatePoolBuyRequestInput!) {
  createPoolBuyRequest(input: $input) {
    id
  }
}
    `;

export const useCreatePoolBuyRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePoolBuyRequestMutation, TError, CreatePoolBuyRequestMutationVariables, TContext>) => {
    
    return useMutation<CreatePoolBuyRequestMutation, TError, CreatePoolBuyRequestMutationVariables, TContext>(
      {
    mutationKey: ['createPoolBuyRequest'],
    mutationFn: useFetchData<CreatePoolBuyRequestMutation, CreatePoolBuyRequestMutationVariables>(CreatePoolBuyRequestDocument),
    ...options
  }
    )};

useCreatePoolBuyRequestMutation.getKey = () => ['createPoolBuyRequest'];

export const InstitutionsPageDataDocument = `
    query institutionsPageData {
  getMarketplaceInstitutions {
    id
    name
    institutionType
    cuNumber
    stateAbbrev
    totalAssets
    nameShort
  }
}
    `;

export const useInstitutionsPageDataQuery = <
      TData = InstitutionsPageDataQuery,
      TError = unknown
    >(
      variables?: InstitutionsPageDataQueryVariables,
      options?: Omit<UseQueryOptions<InstitutionsPageDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InstitutionsPageDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InstitutionsPageDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['institutionsPageData'] : ['institutionsPageData', variables],
    queryFn: useFetchData<InstitutionsPageDataQuery, InstitutionsPageDataQueryVariables>(InstitutionsPageDataDocument).bind(null, variables),
    ...options
  }
    )};

useInstitutionsPageDataQuery.getKey = (variables?: InstitutionsPageDataQueryVariables) => variables === undefined ? ['institutionsPageData'] : ['institutionsPageData', variables];

export const FavoriteInstitutionsDocument = `
    query favoriteInstitutions {
  getFavoriteInstitutionIds
}
    `;

export const useFavoriteInstitutionsQuery = <
      TData = FavoriteInstitutionsQuery,
      TError = unknown
    >(
      variables?: FavoriteInstitutionsQueryVariables,
      options?: Omit<UseQueryOptions<FavoriteInstitutionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FavoriteInstitutionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<FavoriteInstitutionsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['favoriteInstitutions'] : ['favoriteInstitutions', variables],
    queryFn: useFetchData<FavoriteInstitutionsQuery, FavoriteInstitutionsQueryVariables>(FavoriteInstitutionsDocument).bind(null, variables),
    ...options
  }
    )};

useFavoriteInstitutionsQuery.getKey = (variables?: FavoriteInstitutionsQueryVariables) => variables === undefined ? ['favoriteInstitutions'] : ['favoriteInstitutions', variables];

export const AddFavoriteInstitutionDocument = `
    mutation addFavoriteInstitution($institutionId: Int!) {
  addFavoriteInstitution(institutionId: $institutionId)
}
    `;

export const useAddFavoriteInstitutionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddFavoriteInstitutionMutation, TError, AddFavoriteInstitutionMutationVariables, TContext>) => {
    
    return useMutation<AddFavoriteInstitutionMutation, TError, AddFavoriteInstitutionMutationVariables, TContext>(
      {
    mutationKey: ['addFavoriteInstitution'],
    mutationFn: useFetchData<AddFavoriteInstitutionMutation, AddFavoriteInstitutionMutationVariables>(AddFavoriteInstitutionDocument),
    ...options
  }
    )};

useAddFavoriteInstitutionMutation.getKey = () => ['addFavoriteInstitution'];

export const RemoveFavoriteInstitutionDocument = `
    mutation removeFavoriteInstitution($institutionId: Int!) {
  removeFavoriteInstitution(institutionId: $institutionId)
}
    `;

export const useRemoveFavoriteInstitutionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveFavoriteInstitutionMutation, TError, RemoveFavoriteInstitutionMutationVariables, TContext>) => {
    
    return useMutation<RemoveFavoriteInstitutionMutation, TError, RemoveFavoriteInstitutionMutationVariables, TContext>(
      {
    mutationKey: ['removeFavoriteInstitution'],
    mutationFn: useFetchData<RemoveFavoriteInstitutionMutation, RemoveFavoriteInstitutionMutationVariables>(RemoveFavoriteInstitutionDocument),
    ...options
  }
    )};

useRemoveFavoriteInstitutionMutation.getKey = () => ['removeFavoriteInstitution'];

export const GetElementDocument = `
    query getElement($portfolioId: Int!, $elementType: Report_ElementType!, $elementSetting: Report_ElementSettingsInput!, $requestId: String) {
  report_getElement(
    portfolioId: $portfolioId
    elementType: $elementType
    elementSetting: $elementSetting
    requestId: $requestId
  ) {
    requestId
    status
    truncated
    notes
    error
    numStrats
    debugSqlStrings
    chartData
    tableData {
      headers {
        displayName
        type
        sortable
        colSpan
        rowSpan
        children {
          displayName
          type
          sortable
          colSpan
          rowSpan
        }
      }
      rows {
        rowClass
        cssId
        cells {
          value
          displayValue
          valueType
          href
          bold
          colClass
          hoverText
          colSpan
          rowSpan
          sortKey
          altSortKey
          children {
            value
            displayValue
            valueType
            href
            bold
            colSpan
            rowSpan
          }
        }
      }
    }
  }
}
    `;

export const useGetElementQuery = <
      TData = GetElementQuery,
      TError = unknown
    >(
      variables: GetElementQueryVariables,
      options?: Omit<UseQueryOptions<GetElementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetElementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetElementQuery, TError, TData>(
      {
    queryKey: ['getElement', variables],
    queryFn: useFetchData<GetElementQuery, GetElementQueryVariables>(GetElementDocument).bind(null, variables),
    ...options
  }
    )};

useGetElementQuery.getKey = (variables: GetElementQueryVariables) => ['getElement', variables];

export const GetManagePoolLoansDocument = `
    query getManagePoolLoans($poolId: ID) {
  poolLoans(poolId: $poolId) {
    loan {
      id
      loanNumber
    }
  }
}
    `;

export const useGetManagePoolLoansQuery = <
      TData = GetManagePoolLoansQuery,
      TError = unknown
    >(
      variables?: GetManagePoolLoansQueryVariables,
      options?: Omit<UseQueryOptions<GetManagePoolLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetManagePoolLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetManagePoolLoansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getManagePoolLoans'] : ['getManagePoolLoans', variables],
    queryFn: useFetchData<GetManagePoolLoansQuery, GetManagePoolLoansQueryVariables>(GetManagePoolLoansDocument).bind(null, variables),
    ...options
  }
    )};

useGetManagePoolLoansQuery.getKey = (variables?: GetManagePoolLoansQueryVariables) => variables === undefined ? ['getManagePoolLoans'] : ['getManagePoolLoans', variables];

export const GetPresetElementDocument = `
    query getPresetElement($portfolioId: Int!, $elementSetting: Report_ElementSettingsInput!, $requestId: String!, $dataLevel: Report_DataLevel) {
  report_getPresetElement(
    portfolioId: $portfolioId
    elementSetting: $elementSetting
    requestId: $requestId
    dataLevel: $dataLevel
  ) {
    ...elementData
  }
}
    ${ElementDataFragmentDoc}`;

export const useGetPresetElementQuery = <
      TData = GetPresetElementQuery,
      TError = unknown
    >(
      variables: GetPresetElementQueryVariables,
      options?: Omit<UseQueryOptions<GetPresetElementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPresetElementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPresetElementQuery, TError, TData>(
      {
    queryKey: ['getPresetElement', variables],
    queryFn: useFetchData<GetPresetElementQuery, GetPresetElementQueryVariables>(GetPresetElementDocument).bind(null, variables),
    ...options
  }
    )};

useGetPresetElementQuery.getKey = (variables: GetPresetElementQueryVariables) => ['getPresetElement', variables];

export const BatchGetPresetElementsDocument = `
    query batchGetPresetElements($portfolioId: Int!, $elementSetting: Report_ElementSettingsInput!, $requestIds: [String!]!, $dataLevel: Report_DataLevel) {
  report_batchGetPresetElements(
    portfolioId: $portfolioId
    elementSetting: $elementSetting
    requestIds: $requestIds
    dataLevel: $dataLevel
  ) {
    ...elementData
  }
}
    ${ElementDataFragmentDoc}`;

export const useBatchGetPresetElementsQuery = <
      TData = BatchGetPresetElementsQuery,
      TError = unknown
    >(
      variables: BatchGetPresetElementsQueryVariables,
      options?: Omit<UseQueryOptions<BatchGetPresetElementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BatchGetPresetElementsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BatchGetPresetElementsQuery, TError, TData>(
      {
    queryKey: ['batchGetPresetElements', variables],
    queryFn: useFetchData<BatchGetPresetElementsQuery, BatchGetPresetElementsQueryVariables>(BatchGetPresetElementsDocument).bind(null, variables),
    ...options
  }
    )};

useBatchGetPresetElementsQuery.getKey = (variables: BatchGetPresetElementsQueryVariables) => ['batchGetPresetElements', variables];

export const GetPublicPresetElementDocument = `
    query getPublicPresetElement($institutionId: Int!, $elementKey: String!, $poolId: ID!) {
  report_getPublicPresetElement(
    institutionId: $institutionId
    elementKey: $elementKey
    poolId: $poolId
  ) {
    ...elementData
  }
}
    ${ElementDataFragmentDoc}`;

export const useGetPublicPresetElementQuery = <
      TData = GetPublicPresetElementQuery,
      TError = unknown
    >(
      variables: GetPublicPresetElementQueryVariables,
      options?: Omit<UseQueryOptions<GetPublicPresetElementQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPublicPresetElementQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPublicPresetElementQuery, TError, TData>(
      {
    queryKey: ['getPublicPresetElement', variables],
    queryFn: useFetchData<GetPublicPresetElementQuery, GetPublicPresetElementQueryVariables>(GetPublicPresetElementDocument).bind(null, variables),
    ...options
  }
    )};

useGetPublicPresetElementQuery.getKey = (variables: GetPublicPresetElementQueryVariables) => ['getPublicPresetElement', variables];

export const BatchGetPublicPresetElementsDocument = `
    query batchGetPublicPresetElements($institutionId: Int!, $elementKeys: [String!]!, $poolId: ID!) {
  report_batchGetPublicPresetElements(
    institutionId: $institutionId
    elementKeys: $elementKeys
    poolId: $poolId
  ) {
    ...elementData
  }
}
    ${ElementDataFragmentDoc}`;

export const useBatchGetPublicPresetElementsQuery = <
      TData = BatchGetPublicPresetElementsQuery,
      TError = unknown
    >(
      variables: BatchGetPublicPresetElementsQueryVariables,
      options?: Omit<UseQueryOptions<BatchGetPublicPresetElementsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BatchGetPublicPresetElementsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BatchGetPublicPresetElementsQuery, TError, TData>(
      {
    queryKey: ['batchGetPublicPresetElements', variables],
    queryFn: useFetchData<BatchGetPublicPresetElementsQuery, BatchGetPublicPresetElementsQueryVariables>(BatchGetPublicPresetElementsDocument).bind(null, variables),
    ...options
  }
    )};

useBatchGetPublicPresetElementsQuery.getKey = (variables: BatchGetPublicPresetElementsQueryVariables) => ['batchGetPublicPresetElements', variables];

export const SendTransactionsDocument = `
    mutation SendTransactions($portfolioId: Int!, $poolId: Int!) {
  sendTransactions(portfolioId: $portfolioId, poolId: $poolId)
}
    `;

export const useSendTransactionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendTransactionsMutation, TError, SendTransactionsMutationVariables, TContext>) => {
    
    return useMutation<SendTransactionsMutation, TError, SendTransactionsMutationVariables, TContext>(
      {
    mutationKey: ['SendTransactions'],
    mutationFn: useFetchData<SendTransactionsMutation, SendTransactionsMutationVariables>(SendTransactionsDocument),
    ...options
  }
    )};

useSendTransactionsMutation.getKey = () => ['SendTransactions'];

export const GetAllPortfolioDataDatesDocument = `
    query getAllPortfolioDataDates($portfolioId: Int) {
  user_getAllPortfolioDataDates(portfolioId: $portfolioId) {
    dates
    error
    success
  }
}
    `;

export const useGetAllPortfolioDataDatesQuery = <
      TData = GetAllPortfolioDataDatesQuery,
      TError = unknown
    >(
      variables?: GetAllPortfolioDataDatesQueryVariables,
      options?: Omit<UseQueryOptions<GetAllPortfolioDataDatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllPortfolioDataDatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllPortfolioDataDatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAllPortfolioDataDates'] : ['getAllPortfolioDataDates', variables],
    queryFn: useFetchData<GetAllPortfolioDataDatesQuery, GetAllPortfolioDataDatesQueryVariables>(GetAllPortfolioDataDatesDocument).bind(null, variables),
    ...options
  }
    )};

useGetAllPortfolioDataDatesQuery.getKey = (variables?: GetAllPortfolioDataDatesQueryVariables) => variables === undefined ? ['getAllPortfolioDataDates'] : ['getAllPortfolioDataDates', variables];

export const GetLoansForSavedGroupDocument = `
    query getLoansForSavedGroup($portfolioId: Int!, $elementType: Report_ElementType!, $elementSetting: Report_ElementSettingsInput!, $requestId: String) {
  report_getElement(
    portfolioId: $portfolioId
    elementType: $elementType
    elementSetting: $elementSetting
    requestId: $requestId
  ) {
    requestId
    status
    error
    truncated
    tableData {
      headers {
        displayName
        type
        sortable
        fieldName
      }
      rows {
        cells {
          value
          displayValue
          valueType
        }
      }
    }
  }
}
    `;

export const useGetLoansForSavedGroupQuery = <
      TData = GetLoansForSavedGroupQuery,
      TError = unknown
    >(
      variables: GetLoansForSavedGroupQueryVariables,
      options?: Omit<UseQueryOptions<GetLoansForSavedGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoansForSavedGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoansForSavedGroupQuery, TError, TData>(
      {
    queryKey: ['getLoansForSavedGroup', variables],
    queryFn: useFetchData<GetLoansForSavedGroupQuery, GetLoansForSavedGroupQueryVariables>(GetLoansForSavedGroupDocument).bind(null, variables),
    ...options
  }
    )};

useGetLoansForSavedGroupQuery.getKey = (variables: GetLoansForSavedGroupQueryVariables) => ['getLoansForSavedGroup', variables];

export const GetLoanIdNumbersBySavedGroupDocument = `
    query getLoanIdNumbersBySavedGroup($portfolioId: Int!, $loanGroupId: Int!) {
  report_getLoanIdNumbersBySavedGroup(
    portfolioId: $portfolioId
    loanGroupId: $loanGroupId
  ) {
    loanIdNumbers
  }
}
    `;

export const useGetLoanIdNumbersBySavedGroupQuery = <
      TData = GetLoanIdNumbersBySavedGroupQuery,
      TError = unknown
    >(
      variables: GetLoanIdNumbersBySavedGroupQueryVariables,
      options?: Omit<UseQueryOptions<GetLoanIdNumbersBySavedGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoanIdNumbersBySavedGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoanIdNumbersBySavedGroupQuery, TError, TData>(
      {
    queryKey: ['getLoanIdNumbersBySavedGroup', variables],
    queryFn: useFetchData<GetLoanIdNumbersBySavedGroupQuery, GetLoanIdNumbersBySavedGroupQueryVariables>(GetLoanIdNumbersBySavedGroupDocument).bind(null, variables),
    ...options
  }
    )};

useGetLoanIdNumbersBySavedGroupQuery.getKey = (variables: GetLoanIdNumbersBySavedGroupQueryVariables) => ['getLoanIdNumbersBySavedGroup', variables];

export const GetSavedLoanGroupsDocument = `
    query getSavedLoanGroups($portfolioId: Int!) {
  report_getLoanGroups(portfolioId: $portfolioId) {
    id
    name
    description
    recordCount
    createdByUsername
    createdByDate
    lastModifiedByUsername
    lastModifiedByDate
    shareStatus
    recordCount
  }
}
    `;

export const useGetSavedLoanGroupsQuery = <
      TData = GetSavedLoanGroupsQuery,
      TError = unknown
    >(
      variables: GetSavedLoanGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetSavedLoanGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSavedLoanGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSavedLoanGroupsQuery, TError, TData>(
      {
    queryKey: ['getSavedLoanGroups', variables],
    queryFn: useFetchData<GetSavedLoanGroupsQuery, GetSavedLoanGroupsQueryVariables>(GetSavedLoanGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSavedLoanGroupsQuery.getKey = (variables: GetSavedLoanGroupsQueryVariables) => ['getSavedLoanGroups', variables];

export const GetInstitutionByCharterNumberDocument = `
    query getInstitutionByCharterNumber($institutionId: Int!, $charterNumbers: [Int!]!) {
  report_getInstitutionByCharterNumber(
    institutionId: $institutionId
    charterNumbers: $charterNumbers
  ) {
    cuNumber
    institutionId
    cuName
    stateAbbrev
  }
}
    `;

export const useGetInstitutionByCharterNumberQuery = <
      TData = GetInstitutionByCharterNumberQuery,
      TError = unknown
    >(
      variables: GetInstitutionByCharterNumberQueryVariables,
      options?: Omit<UseQueryOptions<GetInstitutionByCharterNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInstitutionByCharterNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInstitutionByCharterNumberQuery, TError, TData>(
      {
    queryKey: ['getInstitutionByCharterNumber', variables],
    queryFn: useFetchData<GetInstitutionByCharterNumberQuery, GetInstitutionByCharterNumberQueryVariables>(GetInstitutionByCharterNumberDocument).bind(null, variables),
    ...options
  }
    )};

useGetInstitutionByCharterNumberQuery.getKey = (variables: GetInstitutionByCharterNumberQueryVariables) => ['getInstitutionByCharterNumber', variables];

export const GetClientDocument = `
    query GetClient($id: ID!) {
  client(id: $id) {
    id
    companyName
    contactPerson
    contactEmail
    contactPhone
    addressLine1
    addressLine2
    city
    state
    postalCode
    country
    isActive
    createdDate
    modifiedDate
    pools {
      id
      clientId
      poolNumber
      poolName
      description
      servicingFeePercentage
      platformFeePercentage
      effectiveDate
      endDate
      isRecourse
      poolStatus
      poolType
      isActive
      createdDate
      modifiedDate
    }
    loans {
      id
      loanNumber
      paxLoanIdentifier
      originalBalance
      currentBalance
      interestRate
      originationDate
      maturityDate
      clientId
      loanStatus
      isActive
      createdDate
      modifiedDate
    }
  }
}
    `;

export const useGetClientQuery = <
      TData = GetClientQuery,
      TError = unknown
    >(
      variables: GetClientQueryVariables,
      options?: Omit<UseQueryOptions<GetClientQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetClientQuery, TError, TData>(
      {
    queryKey: ['GetClient', variables],
    queryFn: useFetchData<GetClientQuery, GetClientQueryVariables>(GetClientDocument).bind(null, variables),
    ...options
  }
    )};

useGetClientQuery.getKey = (variables: GetClientQueryVariables) => ['GetClient', variables];

export const GetClientsDocument = `
    query GetClients($isActive: Boolean, $limit: Int, $offset: Int) {
  clients(isActive: $isActive, limit: $limit, offset: $offset) {
    id
    companyName
    contactPerson
    contactEmail
    contactPhone
    addressLine1
    addressLine2
    city
    state
    postalCode
    country
    isActive
    createdDate
    modifiedDate
  }
}
    `;

export const useGetClientsQuery = <
      TData = GetClientsQuery,
      TError = unknown
    >(
      variables?: GetClientsQueryVariables,
      options?: Omit<UseQueryOptions<GetClientsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetClientsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetClients'] : ['GetClients', variables],
    queryFn: useFetchData<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument).bind(null, variables),
    ...options
  }
    )};

useGetClientsQuery.getKey = (variables?: GetClientsQueryVariables) => variables === undefined ? ['GetClients'] : ['GetClients', variables];

export const GetLoanDocument = `
    query GetLoan($id: ID!) {
  loan(id: $id) {
    id
    loanNumber
    paxLoanIdentifier
    originalBalance
    currentBalance
    interestRate
    originationDate
    maturityDate
    clientId
    loanStatus
    isActive
    createdDate
    modifiedDate
    client {
      id
      companyName
      contactPerson
      contactEmail
      contactPhone
      addressLine1
      addressLine2
      city
      state
      postalCode
      country
      isActive
      createdDate
      modifiedDate
    }
    poolLoans {
      id
      poolId
      loanId
      clientId
      poolLoanStatus
      effectiveDate
      endDate
      modifiedDate
      originalSalesPrice
    }
  }
}
    `;

export const useGetLoanQuery = <
      TData = GetLoanQuery,
      TError = unknown
    >(
      variables: GetLoanQueryVariables,
      options?: Omit<UseQueryOptions<GetLoanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoanQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoanQuery, TError, TData>(
      {
    queryKey: ['GetLoan', variables],
    queryFn: useFetchData<GetLoanQuery, GetLoanQueryVariables>(GetLoanDocument).bind(null, variables),
    ...options
  }
    )};

useGetLoanQuery.getKey = (variables: GetLoanQueryVariables) => ['GetLoan', variables];

export const GetLoansDocument = `
    query GetLoans($clientId: Int, $loanStatus: String, $isActive: Boolean, $limit: Int, $offset: Int) {
  loans(
    clientId: $clientId
    loanStatus: $loanStatus
    isActive: $isActive
    limit: $limit
    offset: $offset
  ) {
    id
    loanNumber
    paxLoanIdentifier
    originalBalance
    currentBalance
    interestRate
    originationDate
    maturityDate
    clientId
    loanStatus
    isActive
    createdDate
    modifiedDate
  }
}
    `;

export const useGetLoansQuery = <
      TData = GetLoansQuery,
      TError = unknown
    >(
      variables?: GetLoansQueryVariables,
      options?: Omit<UseQueryOptions<GetLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetLoans'] : ['GetLoans', variables],
    queryFn: useFetchData<GetLoansQuery, GetLoansQueryVariables>(GetLoansDocument).bind(null, variables),
    ...options
  }
    )};

useGetLoansQuery.getKey = (variables?: GetLoansQueryVariables) => variables === undefined ? ['GetLoans'] : ['GetLoans', variables];

export const GetPoolDocument = `
    query GetPool($id: Int!) {
  pool(id: $id) {
    id
    clientId
    loanPortfolioId
    poolNumber
    poolName
    description
    servicingFeePercentage
    platformFeePercentage
    effectiveDate
    endDate
    isRecourse
    poolStatus
    poolType
    netYield
    isActive
    createdDate
    modifiedDate
    client {
      id
      companyName
      contactPerson
      contactEmail
      contactPhone
      addressLine1
      addressLine2
      city
      state
      postalCode
      country
      isActive
      createdDate
      modifiedDate
    }
    poolLoans {
      id
      poolId
      loanId
      clientId
      poolLoanStatus
      effectiveDate
      endDate
      modifiedDate
      originalSalesPrice
    }
    participants {
      id
      poolId
      buyerId
      percentage
      buyer {
        companyName
      }
      paysPlatformFee
      effectiveDate
      endDate
      isActive
      isSeller
      isServicer
      modifiedDate
    }
    loans {
      id
      loanNumber
      maturityDate
      originalBalance
      currentBalance
      isActive
    }
    listing {
      listingDate
      price
      carveOutPermitted
      dueDiligencePeriod
      dueDiligencePeriodDays
    }
  }
}
    `;

export const useGetPoolQuery = <
      TData = GetPoolQuery,
      TError = unknown
    >(
      variables: GetPoolQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolQuery, TError, TData>(
      {
    queryKey: ['GetPool', variables],
    queryFn: useFetchData<GetPoolQuery, GetPoolQueryVariables>(GetPoolDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolQuery.getKey = (variables: GetPoolQueryVariables) => ['GetPool', variables];

export const GetPoolWithStagingDocument = `
    query GetPoolWithStaging($id: Int!, $reportingPeriod: String!) {
  pool(id: $id) {
    id
    clientId
    poolNumber
    poolName
    description
    servicingFeePercentage
    platformFeePercentage
    effectiveDate
    endDate
    isRecourse
    poolStatus
    poolType
    isActive
    createdDate
    modifiedDate
    stagingSummary(reportingPeriod: $reportingPeriod) {
      reportingPeriod
      clientId
      poolId
      currentBalance
      paymentAmount
      principalPaid
      interestPaid
      lateFeesPaid
      otherFeesPaid
      chargeOffAmount
      recoveryAmount
      accruedInterest
      buybackAmount
    }
    remittanceStaging(reportingPeriod: $reportingPeriod) {
      id
      clientId
      poolId
      loanId
      coreLoanId
      reportingPeriod
      receivedDate
      effectiveDate
      paymentAmount
      principalPaid
      interestPaid
      lateFeesPaid
      otherFeesPaid
      nextPaymentDate
      chargeOffAmount
      chargeOffDate
      recoveryAmount
      isTdr
      bankruptcyChapter
      bankruptcyDate
      daysPastDue
      isNonAccrual
      nonAccrualDate
      currentBalance
      accruedInterest
      currentInterestRate
      status
      processedDate
      createdDate
      updatedDate
      loanNumber
      loanStatus
      scheduledPayment
      creditLimit
      loanType
      loanSubcategoryId
      amountPastDue
      lastPaymentDate
      chargeOffBalance
      chargeOffType
      buybackAmount
      recoveryBalance
      recoveryDate
      loanLevelServiceFee
      cpiInsRefund
      otherFeeIndicator
      delinquentEver
      isBankruptcy
      isFrozen
      isReversal
      paProcessedDate
      filename
      errorCode
      errorMessage
      additionalFields
    }
  }
}
    `;

export const useGetPoolWithStagingQuery = <
      TData = GetPoolWithStagingQuery,
      TError = unknown
    >(
      variables: GetPoolWithStagingQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolWithStagingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolWithStagingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolWithStagingQuery, TError, TData>(
      {
    queryKey: ['GetPoolWithStaging', variables],
    queryFn: useFetchData<GetPoolWithStagingQuery, GetPoolWithStagingQueryVariables>(GetPoolWithStagingDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolWithStagingQuery.getKey = (variables: GetPoolWithStagingQueryVariables) => ['GetPoolWithStaging', variables];

export const GetPoolsDocument = `
    query GetPools($clientId: Int, $isActiveOnly: Boolean) {
  pools(clientId: $clientId, isActiveOnly: $isActiveOnly) {
    id
    clientId
    poolNumber
    poolName
    description
    servicingFeePercentage
    platformFeePercentage
    effectiveDate
    endDate
    isRecourse
    poolStatus
    poolType
    isActive
    createdDate
    modifiedDate
    loanCount
    participants {
      buyerId
      buyer {
        companyName
      }
      isSeller
      percentage
    }
    listing {
      poolId
      price
      soldDate
    }
  }
}
    `;

export const useGetPoolsQuery = <
      TData = GetPoolsQuery,
      TError = unknown
    >(
      variables?: GetPoolsQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPools'] : ['GetPools', variables],
    queryFn: useFetchData<GetPoolsQuery, GetPoolsQueryVariables>(GetPoolsDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolsQuery.getKey = (variables?: GetPoolsQueryVariables) => variables === undefined ? ['GetPools'] : ['GetPools', variables];

export const PoolsForBuyerDocument = `
    query PoolsForBuyer($buyerId: Int!) {
  poolParticipants(buyerId: $buyerId, isActiveOnly: true) {
    id
    buyerId
    percentage
    isSeller
    isServicer
    pool {
      id
      clientId
      client {
        companyName
      }
      poolNumber
      poolName
      description
      servicingFeePercentage
      platformFeePercentage
      effectiveDate
      endDate
      isRecourse
      poolStatus
      poolType
      isActive
      createdDate
      modifiedDate
      loanCount
      listing {
        poolId
        price
        soldDate
      }
    }
  }
}
    `;

export const usePoolsForBuyerQuery = <
      TData = PoolsForBuyerQuery,
      TError = unknown
    >(
      variables: PoolsForBuyerQueryVariables,
      options?: Omit<UseQueryOptions<PoolsForBuyerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PoolsForBuyerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PoolsForBuyerQuery, TError, TData>(
      {
    queryKey: ['PoolsForBuyer', variables],
    queryFn: useFetchData<PoolsForBuyerQuery, PoolsForBuyerQueryVariables>(PoolsForBuyerDocument).bind(null, variables),
    ...options
  }
    )};

usePoolsForBuyerQuery.getKey = (variables: PoolsForBuyerQueryVariables) => ['PoolsForBuyer', variables];

export const GetPoolLoanDocument = `
    query GetPoolLoan($id: ID!) {
  poolLoan(id: $id) {
    id
    poolId
    loanId
    clientId
    poolLoanStatus
    effectiveDate
    endDate
    modifiedDate
    originalSalesPrice
    pool {
      id
      clientId
      poolNumber
      poolName
      description
      servicingFeePercentage
      platformFeePercentage
      effectiveDate
      endDate
      isRecourse
      poolStatus
      poolType
      isActive
      createdDate
      modifiedDate
    }
    loan {
      id
      loanNumber
      paxLoanIdentifier
      originalBalance
      currentBalance
      interestRate
      originationDate
      maturityDate
      clientId
      loanStatus
      isActive
      createdDate
      modifiedDate
    }
  }
}
    `;

export const useGetPoolLoanQuery = <
      TData = GetPoolLoanQuery,
      TError = unknown
    >(
      variables: GetPoolLoanQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolLoanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolLoanQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolLoanQuery, TError, TData>(
      {
    queryKey: ['GetPoolLoan', variables],
    queryFn: useFetchData<GetPoolLoanQuery, GetPoolLoanQueryVariables>(GetPoolLoanDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolLoanQuery.getKey = (variables: GetPoolLoanQueryVariables) => ['GetPoolLoan', variables];

export const GetPoolLoansDocument = `
    query GetPoolLoans($poolId: ID, $loanId: ID, $clientId: Int, $poolLoanStatus: PoolLoanStatus, $limit: Int, $offset: Int) {
  poolLoans(
    poolId: $poolId
    loanId: $loanId
    clientId: $clientId
    poolLoanStatus: $poolLoanStatus
    limit: $limit
    offset: $offset
  ) {
    id
    poolId
    loanId
    clientId
    poolLoanStatus
    effectiveDate
    endDate
    modifiedDate
    originalSalesPrice
  }
}
    `;

export const useGetPoolLoansQuery = <
      TData = GetPoolLoansQuery,
      TError = unknown
    >(
      variables?: GetPoolLoansQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolLoansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPoolLoans'] : ['GetPoolLoans', variables],
    queryFn: useFetchData<GetPoolLoansQuery, GetPoolLoansQueryVariables>(GetPoolLoansDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolLoansQuery.getKey = (variables?: GetPoolLoansQueryVariables) => variables === undefined ? ['GetPoolLoans'] : ['GetPoolLoans', variables];

export const UpsertLoansDocument = `
    mutation UpsertLoans($loans: [UpsertLoanInput!]!) {
  upsertLoans(loans: $loans) {
    id
    loanNumber
    clientId
    currentBalance
    interestRate
    originationDate
    maturityDate
    loanStatus
    isActive
  }
}
    `;

export const useUpsertLoansMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertLoansMutation, TError, UpsertLoansMutationVariables, TContext>) => {
    
    return useMutation<UpsertLoansMutation, TError, UpsertLoansMutationVariables, TContext>(
      {
    mutationKey: ['UpsertLoans'],
    mutationFn: useFetchData<UpsertLoansMutation, UpsertLoansMutationVariables>(UpsertLoansDocument),
    ...options
  }
    )};

useUpsertLoansMutation.getKey = () => ['UpsertLoans'];

export const AddPoolLoansDocument = `
    mutation AddPoolLoans($loans: [AddPoolLoanInput!]!) {
  addPoolLoans(loans: $loans) {
    id
    poolId
    loanId
    clientId
    poolLoanStatus
    effectiveDate
    endDate
    modifiedDate
    originalSalesPrice
  }
}
    `;

export const useAddPoolLoansMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddPoolLoansMutation, TError, AddPoolLoansMutationVariables, TContext>) => {
    
    return useMutation<AddPoolLoansMutation, TError, AddPoolLoansMutationVariables, TContext>(
      {
    mutationKey: ['AddPoolLoans'],
    mutationFn: useFetchData<AddPoolLoansMutation, AddPoolLoansMutationVariables>(AddPoolLoansDocument),
    ...options
  }
    )};

useAddPoolLoansMutation.getKey = () => ['AddPoolLoans'];

export const LoanStatusForPoolByIdDocument = `
    query LoanStatusForPoolById($poolId: ID!, $loanNumbers: [String!]!) {
  loanStatusForPool(input: {poolId: $poolId, loanNumbers: $loanNumbers}) {
    poolId
    poolNumber
    poolStatus
    results {
      loanNumber
      loanId
      status
      inPool
    }
  }
}
    `;

export const useLoanStatusForPoolByIdQuery = <
      TData = LoanStatusForPoolByIdQuery,
      TError = unknown
    >(
      variables: LoanStatusForPoolByIdQueryVariables,
      options?: Omit<UseQueryOptions<LoanStatusForPoolByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LoanStatusForPoolByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LoanStatusForPoolByIdQuery, TError, TData>(
      {
    queryKey: ['LoanStatusForPoolById', variables],
    queryFn: useFetchData<LoanStatusForPoolByIdQuery, LoanStatusForPoolByIdQueryVariables>(LoanStatusForPoolByIdDocument).bind(null, variables),
    ...options
  }
    )};

useLoanStatusForPoolByIdQuery.getKey = (variables: LoanStatusForPoolByIdQueryVariables) => ['LoanStatusForPoolById', variables];

export const LoanStatusForPoolByNumberDocument = `
    query LoanStatusForPoolByNumber($poolNumber: String!, $loanNumbers: [String!]!) {
  loanStatusForPool(input: {poolNumber: $poolNumber, loanNumbers: $loanNumbers}) {
    poolId
    poolNumber
    poolStatus
    results {
      loanNumber
      loanId
      status
      inPool
    }
  }
}
    `;

export const useLoanStatusForPoolByNumberQuery = <
      TData = LoanStatusForPoolByNumberQuery,
      TError = unknown
    >(
      variables: LoanStatusForPoolByNumberQueryVariables,
      options?: Omit<UseQueryOptions<LoanStatusForPoolByNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LoanStatusForPoolByNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<LoanStatusForPoolByNumberQuery, TError, TData>(
      {
    queryKey: ['LoanStatusForPoolByNumber', variables],
    queryFn: useFetchData<LoanStatusForPoolByNumberQuery, LoanStatusForPoolByNumberQueryVariables>(LoanStatusForPoolByNumberDocument).bind(null, variables),
    ...options
  }
    )};

useLoanStatusForPoolByNumberQuery.getKey = (variables: LoanStatusForPoolByNumberQueryVariables) => ['LoanStatusForPoolByNumber', variables];

export const GetPoolParticipantDocument = `
    query GetPoolParticipant($id: ID!) {
  poolParticipant(id: $id) {
    id
    poolId
    buyerId
    percentage
    paysPlatformFee
    effectiveDate
    endDate
    isActive
    isSeller
    isServicer
    modifiedDate
    pool {
      id
      clientId
      poolNumber
      poolName
      description
      servicingFeePercentage
      platformFeePercentage
      effectiveDate
      endDate
      isRecourse
      poolStatus
      poolType
      isActive
      createdDate
      modifiedDate
    }
    buyer {
      id
      companyName
      contactPerson
      contactEmail
      contactPhone
      addressLine1
      addressLine2
      city
      state
      postalCode
      country
      isActive
      createdDate
      modifiedDate
    }
  }
}
    `;

export const useGetPoolParticipantQuery = <
      TData = GetPoolParticipantQuery,
      TError = unknown
    >(
      variables: GetPoolParticipantQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolParticipantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolParticipantQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolParticipantQuery, TError, TData>(
      {
    queryKey: ['GetPoolParticipant', variables],
    queryFn: useFetchData<GetPoolParticipantQuery, GetPoolParticipantQueryVariables>(GetPoolParticipantDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolParticipantQuery.getKey = (variables: GetPoolParticipantQueryVariables) => ['GetPoolParticipant', variables];

export const GetPoolParticipantsDocument = `
    query GetPoolParticipants($poolId: ID, $buyerId: Int, $isActiveOnly: Boolean) {
  poolParticipants(
    poolId: $poolId
    buyerId: $buyerId
    isActiveOnly: $isActiveOnly
  ) {
    id
    poolId
    buyerId
    percentage
    paysPlatformFee
    effectiveDate
    endDate
    isActive
    isSeller
    isServicer
    modifiedDate
  }
}
    `;

export const useGetPoolParticipantsQuery = <
      TData = GetPoolParticipantsQuery,
      TError = unknown
    >(
      variables?: GetPoolParticipantsQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolParticipantsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolParticipantsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolParticipantsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPoolParticipants'] : ['GetPoolParticipants', variables],
    queryFn: useFetchData<GetPoolParticipantsQuery, GetPoolParticipantsQueryVariables>(GetPoolParticipantsDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolParticipantsQuery.getKey = (variables?: GetPoolParticipantsQueryVariables) => variables === undefined ? ['GetPoolParticipants'] : ['GetPoolParticipants', variables];

export const GetRemittanceStagingDocument = `
    query GetRemittanceStaging($id: ID!) {
  remittanceStaging(id: $id) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useGetRemittanceStagingQuery = <
      TData = GetRemittanceStagingQuery,
      TError = unknown
    >(
      variables: GetRemittanceStagingQueryVariables,
      options?: Omit<UseQueryOptions<GetRemittanceStagingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRemittanceStagingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRemittanceStagingQuery, TError, TData>(
      {
    queryKey: ['GetRemittanceStaging', variables],
    queryFn: useFetchData<GetRemittanceStagingQuery, GetRemittanceStagingQueryVariables>(GetRemittanceStagingDocument).bind(null, variables),
    ...options
  }
    )};

useGetRemittanceStagingQuery.getKey = (variables: GetRemittanceStagingQueryVariables) => ['GetRemittanceStaging', variables];

export const ListRemittanceStagingByPeriodDocument = `
    query ListRemittanceStagingByPeriod($reportingPeriod: String!, $clientId: Int!) {
  remittanceStaging(reportingPeriod: $reportingPeriod, clientId: $clientId) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useListRemittanceStagingByPeriodQuery = <
      TData = ListRemittanceStagingByPeriodQuery,
      TError = unknown
    >(
      variables: ListRemittanceStagingByPeriodQueryVariables,
      options?: Omit<UseQueryOptions<ListRemittanceStagingByPeriodQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListRemittanceStagingByPeriodQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListRemittanceStagingByPeriodQuery, TError, TData>(
      {
    queryKey: ['ListRemittanceStagingByPeriod', variables],
    queryFn: useFetchData<ListRemittanceStagingByPeriodQuery, ListRemittanceStagingByPeriodQueryVariables>(ListRemittanceStagingByPeriodDocument).bind(null, variables),
    ...options
  }
    )};

useListRemittanceStagingByPeriodQuery.getKey = (variables: ListRemittanceStagingByPeriodQueryVariables) => ['ListRemittanceStagingByPeriod', variables];

export const ListRemittanceStagingByPoolDocument = `
    query ListRemittanceStagingByPool($reportingPeriod: String!, $poolNumber: String!) {
  remittanceStaging(reportingPeriod: $reportingPeriod, poolNumber: $poolNumber) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useListRemittanceStagingByPoolQuery = <
      TData = ListRemittanceStagingByPoolQuery,
      TError = unknown
    >(
      variables: ListRemittanceStagingByPoolQueryVariables,
      options?: Omit<UseQueryOptions<ListRemittanceStagingByPoolQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListRemittanceStagingByPoolQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListRemittanceStagingByPoolQuery, TError, TData>(
      {
    queryKey: ['ListRemittanceStagingByPool', variables],
    queryFn: useFetchData<ListRemittanceStagingByPoolQuery, ListRemittanceStagingByPoolQueryVariables>(ListRemittanceStagingByPoolDocument).bind(null, variables),
    ...options
  }
    )};

useListRemittanceStagingByPoolQuery.getKey = (variables: ListRemittanceStagingByPoolQueryVariables) => ['ListRemittanceStagingByPool', variables];

export const ListRemittanceStagingByParticipantDocument = `
    query ListRemittanceStagingByParticipant($reportingPeriod: String!, $participantId: ID!) {
  remittanceStaging(
    reportingPeriod: $reportingPeriod
    participantId: $participantId
  ) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useListRemittanceStagingByParticipantQuery = <
      TData = ListRemittanceStagingByParticipantQuery,
      TError = unknown
    >(
      variables: ListRemittanceStagingByParticipantQueryVariables,
      options?: Omit<UseQueryOptions<ListRemittanceStagingByParticipantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListRemittanceStagingByParticipantQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListRemittanceStagingByParticipantQuery, TError, TData>(
      {
    queryKey: ['ListRemittanceStagingByParticipant', variables],
    queryFn: useFetchData<ListRemittanceStagingByParticipantQuery, ListRemittanceStagingByParticipantQueryVariables>(ListRemittanceStagingByParticipantDocument).bind(null, variables),
    ...options
  }
    )};

useListRemittanceStagingByParticipantQuery.getKey = (variables: ListRemittanceStagingByParticipantQueryVariables) => ['ListRemittanceStagingByParticipant', variables];

export const ListRemittanceStagingByLoanDocument = `
    query ListRemittanceStagingByLoan($reportingPeriod: String!, $loanNumber: String!, $loanClientId: Int!) {
  remittanceStaging(
    reportingPeriod: $reportingPeriod
    loanNumber: $loanNumber
    loanClientId: $loanClientId
  ) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useListRemittanceStagingByLoanQuery = <
      TData = ListRemittanceStagingByLoanQuery,
      TError = unknown
    >(
      variables: ListRemittanceStagingByLoanQueryVariables,
      options?: Omit<UseQueryOptions<ListRemittanceStagingByLoanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListRemittanceStagingByLoanQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListRemittanceStagingByLoanQuery, TError, TData>(
      {
    queryKey: ['ListRemittanceStagingByLoan', variables],
    queryFn: useFetchData<ListRemittanceStagingByLoanQuery, ListRemittanceStagingByLoanQueryVariables>(ListRemittanceStagingByLoanDocument).bind(null, variables),
    ...options
  }
    )};

useListRemittanceStagingByLoanQuery.getKey = (variables: ListRemittanceStagingByLoanQueryVariables) => ['ListRemittanceStagingByLoan', variables];

export const ListRemittanceStagingByStatusDocument = `
    query ListRemittanceStagingByStatus($reportingPeriod: String!, $clientId: Int!, $status: RemittanceStagingStatus!) {
  remittanceStaging(
    reportingPeriod: $reportingPeriod
    clientId: $clientId
    status: $status
  ) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useListRemittanceStagingByStatusQuery = <
      TData = ListRemittanceStagingByStatusQuery,
      TError = unknown
    >(
      variables: ListRemittanceStagingByStatusQueryVariables,
      options?: Omit<UseQueryOptions<ListRemittanceStagingByStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListRemittanceStagingByStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListRemittanceStagingByStatusQuery, TError, TData>(
      {
    queryKey: ['ListRemittanceStagingByStatus', variables],
    queryFn: useFetchData<ListRemittanceStagingByStatusQuery, ListRemittanceStagingByStatusQueryVariables>(ListRemittanceStagingByStatusDocument).bind(null, variables),
    ...options
  }
    )};

useListRemittanceStagingByStatusQuery.getKey = (variables: ListRemittanceStagingByStatusQueryVariables) => ['ListRemittanceStagingByStatus', variables];

export const GetRemittanceStagingSummaryDocument = `
    query GetRemittanceStagingSummary($reportingPeriod: String!, $clientId: Int!, $poolId: ID) {
  remittanceStagingSummary(
    reportingPeriod: $reportingPeriod
    clientId: $clientId
    poolId: $poolId
  ) {
    reportingPeriod
    clientId
    poolId
    currentBalance
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    chargeOffAmount
    recoveryAmount
    accruedInterest
    buybackAmount
  }
}
    `;

export const useGetRemittanceStagingSummaryQuery = <
      TData = GetRemittanceStagingSummaryQuery,
      TError = unknown
    >(
      variables: GetRemittanceStagingSummaryQueryVariables,
      options?: Omit<UseQueryOptions<GetRemittanceStagingSummaryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRemittanceStagingSummaryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRemittanceStagingSummaryQuery, TError, TData>(
      {
    queryKey: ['GetRemittanceStagingSummary', variables],
    queryFn: useFetchData<GetRemittanceStagingSummaryQuery, GetRemittanceStagingSummaryQueryVariables>(GetRemittanceStagingSummaryDocument).bind(null, variables),
    ...options
  }
    )};

useGetRemittanceStagingSummaryQuery.getKey = (variables: GetRemittanceStagingSummaryQueryVariables) => ['GetRemittanceStagingSummary', variables];

export const GetRemittanceStagingErrorsDocument = `
    query GetRemittanceStagingErrors($clientId: Int!, $reportingPeriod: String!, $poolId: ID) {
  remittanceStagingErrors(
    clientId: $clientId
    reportingPeriod: $reportingPeriod
    poolId: $poolId
  ) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    recoveryAmount
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    batchId
    status
    processedDate
    createdDate
    updatedDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffBalance
    chargeOffType
    buybackAmount
    recoveryBalance
    recoveryDate
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    errorCode
    errorMessage
    additionalFields
  }
}
    `;

export const useGetRemittanceStagingErrorsQuery = <
      TData = GetRemittanceStagingErrorsQuery,
      TError = unknown
    >(
      variables: GetRemittanceStagingErrorsQueryVariables,
      options?: Omit<UseQueryOptions<GetRemittanceStagingErrorsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRemittanceStagingErrorsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRemittanceStagingErrorsQuery, TError, TData>(
      {
    queryKey: ['GetRemittanceStagingErrors', variables],
    queryFn: useFetchData<GetRemittanceStagingErrorsQuery, GetRemittanceStagingErrorsQueryVariables>(GetRemittanceStagingErrorsDocument).bind(null, variables),
    ...options
  }
    )};

useGetRemittanceStagingErrorsQuery.getKey = (variables: GetRemittanceStagingErrorsQueryVariables) => ['GetRemittanceStagingErrors', variables];

export const CreateRemittanceStagingDocument = `
    mutation CreateRemittanceStaging($input: CreateRemittanceStagingInput!) {
  createRemittanceStaging(input: $input) {
    id
    clientId
    poolId
    loanId
    reportingPeriod
    status
    createdDate
    updatedDate
  }
}
    `;

export const useCreateRemittanceStagingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRemittanceStagingMutation, TError, CreateRemittanceStagingMutationVariables, TContext>) => {
    
    return useMutation<CreateRemittanceStagingMutation, TError, CreateRemittanceStagingMutationVariables, TContext>(
      {
    mutationKey: ['CreateRemittanceStaging'],
    mutationFn: useFetchData<CreateRemittanceStagingMutation, CreateRemittanceStagingMutationVariables>(CreateRemittanceStagingDocument),
    ...options
  }
    )};

useCreateRemittanceStagingMutation.getKey = () => ['CreateRemittanceStaging'];

export const UpsertRemittanceStagingDocument = `
    mutation UpsertRemittanceStaging($input: UpsertRemittanceStagingInput!) {
  upsertRemittanceStaging(input: $input)
}
    `;

export const useUpsertRemittanceStagingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertRemittanceStagingMutation, TError, UpsertRemittanceStagingMutationVariables, TContext>) => {
    
    return useMutation<UpsertRemittanceStagingMutation, TError, UpsertRemittanceStagingMutationVariables, TContext>(
      {
    mutationKey: ['UpsertRemittanceStaging'],
    mutationFn: useFetchData<UpsertRemittanceStagingMutation, UpsertRemittanceStagingMutationVariables>(UpsertRemittanceStagingDocument),
    ...options
  }
    )};

useUpsertRemittanceStagingMutation.getKey = () => ['UpsertRemittanceStaging'];

export const UpdateRemittanceStagingDocument = `
    mutation UpdateRemittanceStaging($id: ID!, $input: UpdateRemittanceStagingInput!) {
  updateRemittanceStaging(id: $id, input: $input) {
    id
    clientId
    poolId
    loanId
    reportingPeriod
    status
    createdDate
    updatedDate
  }
}
    `;

export const useUpdateRemittanceStagingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRemittanceStagingMutation, TError, UpdateRemittanceStagingMutationVariables, TContext>) => {
    
    return useMutation<UpdateRemittanceStagingMutation, TError, UpdateRemittanceStagingMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRemittanceStaging'],
    mutationFn: useFetchData<UpdateRemittanceStagingMutation, UpdateRemittanceStagingMutationVariables>(UpdateRemittanceStagingDocument),
    ...options
  }
    )};

useUpdateRemittanceStagingMutation.getKey = () => ['UpdateRemittanceStaging'];

export const TransitionRemittanceStagingStatusDocument = `
    mutation TransitionRemittanceStagingStatus($id: ID!, $status: RemittanceStagingStatus!) {
  transitionRemittanceStagingStatus(id: $id, status: $status) {
    id
    status
    updatedDate
  }
}
    `;

export const useTransitionRemittanceStagingStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TransitionRemittanceStagingStatusMutation, TError, TransitionRemittanceStagingStatusMutationVariables, TContext>) => {
    
    return useMutation<TransitionRemittanceStagingStatusMutation, TError, TransitionRemittanceStagingStatusMutationVariables, TContext>(
      {
    mutationKey: ['TransitionRemittanceStagingStatus'],
    mutationFn: useFetchData<TransitionRemittanceStagingStatusMutation, TransitionRemittanceStagingStatusMutationVariables>(TransitionRemittanceStagingStatusDocument),
    ...options
  }
    )};

useTransitionRemittanceStagingStatusMutation.getKey = () => ['TransitionRemittanceStagingStatus'];

export const DeleteRemittanceStagingDocument = `
    mutation DeleteRemittanceStaging($id: ID!) {
  deleteRemittanceStaging(id: $id)
}
    `;

export const useDeleteRemittanceStagingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRemittanceStagingMutation, TError, DeleteRemittanceStagingMutationVariables, TContext>) => {
    
    return useMutation<DeleteRemittanceStagingMutation, TError, DeleteRemittanceStagingMutationVariables, TContext>(
      {
    mutationKey: ['DeleteRemittanceStaging'],
    mutationFn: useFetchData<DeleteRemittanceStagingMutation, DeleteRemittanceStagingMutationVariables>(DeleteRemittanceStagingDocument),
    ...options
  }
    )};

useDeleteRemittanceStagingMutation.getKey = () => ['DeleteRemittanceStaging'];

export const GetClientWithRemittanceStagingDocument = `
    query GetClientWithRemittanceStaging($id: ID!, $reportingPeriod: String!) {
  client(id: $id) {
    id
    companyName
    contactPerson
    contactEmail
    contactPhone
    addressLine1
    addressLine2
    city
    state
    postalCode
    country
    isActive
    createdDate
    modifiedDate
    remittanceStaging(reportingPeriod: $reportingPeriod) {
      id
      clientId
      poolId
      loanId
      reportingPeriod
      status
      paymentAmount
      principalPaid
      interestPaid
      currentBalance
      createdDate
      updatedDate
    }
  }
}
    `;

export const useGetClientWithRemittanceStagingQuery = <
      TData = GetClientWithRemittanceStagingQuery,
      TError = unknown
    >(
      variables: GetClientWithRemittanceStagingQueryVariables,
      options?: Omit<UseQueryOptions<GetClientWithRemittanceStagingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetClientWithRemittanceStagingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetClientWithRemittanceStagingQuery, TError, TData>(
      {
    queryKey: ['GetClientWithRemittanceStaging', variables],
    queryFn: useFetchData<GetClientWithRemittanceStagingQuery, GetClientWithRemittanceStagingQueryVariables>(GetClientWithRemittanceStagingDocument).bind(null, variables),
    ...options
  }
    )};

useGetClientWithRemittanceStagingQuery.getKey = (variables: GetClientWithRemittanceStagingQueryVariables) => ['GetClientWithRemittanceStaging', variables];

export const GetLoanWithRemittanceStagingDocument = `
    query GetLoanWithRemittanceStaging($id: ID!, $reportingPeriod: String!) {
  loan(id: $id) {
    id
    loanNumber
    paxLoanIdentifier
    originalBalance
    currentBalance
    interestRate
    originationDate
    maturityDate
    clientId
    loanStatus
    isActive
    createdDate
    modifiedDate
    remittanceStaging(reportingPeriod: $reportingPeriod) {
      id
      clientId
      poolId
      loanId
      reportingPeriod
      status
      paymentAmount
      principalPaid
      interestPaid
      currentBalance
      createdDate
      updatedDate
    }
  }
}
    `;

export const useGetLoanWithRemittanceStagingQuery = <
      TData = GetLoanWithRemittanceStagingQuery,
      TError = unknown
    >(
      variables: GetLoanWithRemittanceStagingQueryVariables,
      options?: Omit<UseQueryOptions<GetLoanWithRemittanceStagingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoanWithRemittanceStagingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoanWithRemittanceStagingQuery, TError, TData>(
      {
    queryKey: ['GetLoanWithRemittanceStaging', variables],
    queryFn: useFetchData<GetLoanWithRemittanceStagingQuery, GetLoanWithRemittanceStagingQueryVariables>(GetLoanWithRemittanceStagingDocument).bind(null, variables),
    ...options
  }
    )};

useGetLoanWithRemittanceStagingQuery.getKey = (variables: GetLoanWithRemittanceStagingQueryVariables) => ['GetLoanWithRemittanceStaging', variables];

export const GetRemittanceHistoriesDocument = `
    query GetRemittanceHistories($poolId: ID, $reportingPeriod: String) {
  remittanceHistories(poolId: $poolId, reportingPeriod: $reportingPeriod) {
    id
    poolId
    reportingPeriod
    currentStep
    status
    createdAt
    updatedAt
  }
}
    `;

export const useGetRemittanceHistoriesQuery = <
      TData = GetRemittanceHistoriesQuery,
      TError = unknown
    >(
      variables?: GetRemittanceHistoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetRemittanceHistoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRemittanceHistoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRemittanceHistoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRemittanceHistories'] : ['GetRemittanceHistories', variables],
    queryFn: useFetchData<GetRemittanceHistoriesQuery, GetRemittanceHistoriesQueryVariables>(GetRemittanceHistoriesDocument).bind(null, variables),
    ...options
  }
    )};

useGetRemittanceHistoriesQuery.getKey = (variables?: GetRemittanceHistoriesQueryVariables) => variables === undefined ? ['GetRemittanceHistories'] : ['GetRemittanceHistories', variables];

export const GetRemittanceHistoriesByClientAndRoleDocument = `
    query GetRemittanceHistoriesByClientAndRole($clientId: Int, $role: PoolRole) {
  remittanceHistories(clientId: $clientId, role: $role) {
    id
    poolId
    reportingPeriod
    status
    currentStep
    pool {
      id
      clientId
      client {
        companyName
      }
      poolNumber
      poolName
      description
      servicingFeePercentage
      platformFeePercentage
      effectiveDate
      endDate
      isRecourse
      poolStatus
      poolType
      isActive
      createdDate
      modifiedDate
      loanCount
      participants {
        buyerId
        buyer {
          companyName
        }
        isSeller
        percentage
      }
      listing {
        poolId
        price
        soldDate
      }
    }
  }
}
    `;

export const useGetRemittanceHistoriesByClientAndRoleQuery = <
      TData = GetRemittanceHistoriesByClientAndRoleQuery,
      TError = unknown
    >(
      variables?: GetRemittanceHistoriesByClientAndRoleQueryVariables,
      options?: Omit<UseQueryOptions<GetRemittanceHistoriesByClientAndRoleQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRemittanceHistoriesByClientAndRoleQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRemittanceHistoriesByClientAndRoleQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRemittanceHistoriesByClientAndRole'] : ['GetRemittanceHistoriesByClientAndRole', variables],
    queryFn: useFetchData<GetRemittanceHistoriesByClientAndRoleQuery, GetRemittanceHistoriesByClientAndRoleQueryVariables>(GetRemittanceHistoriesByClientAndRoleDocument).bind(null, variables),
    ...options
  }
    )};

useGetRemittanceHistoriesByClientAndRoleQuery.getKey = (variables?: GetRemittanceHistoriesByClientAndRoleQueryVariables) => variables === undefined ? ['GetRemittanceHistoriesByClientAndRole'] : ['GetRemittanceHistoriesByClientAndRole', variables];

export const CreateRemittanceHistoryDocument = `
    mutation CreateRemittanceHistory($input: CreateRemittanceHistoryInput!) {
  createRemittanceHistory(input: $input) {
    id
    poolId
    reportingPeriod
    currentStep
    status
    createdAt
    updatedAt
  }
}
    `;

export const useCreateRemittanceHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateRemittanceHistoryMutation, TError, CreateRemittanceHistoryMutationVariables, TContext>) => {
    
    return useMutation<CreateRemittanceHistoryMutation, TError, CreateRemittanceHistoryMutationVariables, TContext>(
      {
    mutationKey: ['CreateRemittanceHistory'],
    mutationFn: useFetchData<CreateRemittanceHistoryMutation, CreateRemittanceHistoryMutationVariables>(CreateRemittanceHistoryDocument),
    ...options
  }
    )};

useCreateRemittanceHistoryMutation.getKey = () => ['CreateRemittanceHistory'];

export const UpdateRemittanceHistoryDocument = `
    mutation UpdateRemittanceHistory($id: ID!, $input: UpdateRemittanceHistoryInput!) {
  updateRemittanceHistory(id: $id, input: $input) {
    id
    poolId
    reportingPeriod
    currentStep
    status
    updatedAt
  }
}
    `;

export const useUpdateRemittanceHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateRemittanceHistoryMutation, TError, UpdateRemittanceHistoryMutationVariables, TContext>) => {
    
    return useMutation<UpdateRemittanceHistoryMutation, TError, UpdateRemittanceHistoryMutationVariables, TContext>(
      {
    mutationKey: ['UpdateRemittanceHistory'],
    mutationFn: useFetchData<UpdateRemittanceHistoryMutation, UpdateRemittanceHistoryMutationVariables>(UpdateRemittanceHistoryDocument),
    ...options
  }
    )};

useUpdateRemittanceHistoryMutation.getKey = () => ['UpdateRemittanceHistory'];

export const GenerateRemittanceDocument = `
    mutation GenerateRemittance($poolId: Int!) {
  generateRemittance(poolId: $poolId) {
    stagingProcessed
  }
}
    `;

export const useGenerateRemittanceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateRemittanceMutation, TError, GenerateRemittanceMutationVariables, TContext>) => {
    
    return useMutation<GenerateRemittanceMutation, TError, GenerateRemittanceMutationVariables, TContext>(
      {
    mutationKey: ['GenerateRemittance'],
    mutationFn: useFetchData<GenerateRemittanceMutation, GenerateRemittanceMutationVariables>(GenerateRemittanceDocument),
    ...options
  }
    )};

useGenerateRemittanceMutation.getKey = () => ['GenerateRemittance'];

export const GetPreviewPoolRemittanceSummaryDocument = `
    query GetPreviewPoolRemittanceSummary($poolId: Int!, $participantClientId: Int) {
  previewPoolRemittanceSummary(
    poolId: $poolId
    participantClientId: $participantClientId
  ) {
    buyerId
    reportingPeriod
    loanCount
    currentBalance
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    chargeOffAmount
    chargeOffBalance
    recoveryAmount
    recoveryBalance
    accruedInterest
    buybackAmount
    servicingFee
    platformFee
    scheduledPayment
    creditLimit
    amountPastDue
    loanLevelServiceFee
    cpiInsRefund
  }
}
    `;

export const useGetPreviewPoolRemittanceSummaryQuery = <
      TData = GetPreviewPoolRemittanceSummaryQuery,
      TError = unknown
    >(
      variables: GetPreviewPoolRemittanceSummaryQueryVariables,
      options?: Omit<UseQueryOptions<GetPreviewPoolRemittanceSummaryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPreviewPoolRemittanceSummaryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPreviewPoolRemittanceSummaryQuery, TError, TData>(
      {
    queryKey: ['GetPreviewPoolRemittanceSummary', variables],
    queryFn: useFetchData<GetPreviewPoolRemittanceSummaryQuery, GetPreviewPoolRemittanceSummaryQueryVariables>(GetPreviewPoolRemittanceSummaryDocument).bind(null, variables),
    ...options
  }
    )};

useGetPreviewPoolRemittanceSummaryQuery.getKey = (variables: GetPreviewPoolRemittanceSummaryQueryVariables) => ['GetPreviewPoolRemittanceSummary', variables];

export const GetPreviewPoolGlSummaryDocument = `
    query GetPreviewPoolGlSummary($poolId: Int!, $participantClientId: Int) {
  previewPoolGlSummary(poolId: $poolId, participantClientId: $participantClientId) {
    clientId
    totalDebits
    totalCredits
    netAmount
    transactionCount
  }
}
    `;

export const useGetPreviewPoolGlSummaryQuery = <
      TData = GetPreviewPoolGlSummaryQuery,
      TError = unknown
    >(
      variables: GetPreviewPoolGlSummaryQueryVariables,
      options?: Omit<UseQueryOptions<GetPreviewPoolGlSummaryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPreviewPoolGlSummaryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPreviewPoolGlSummaryQuery, TError, TData>(
      {
    queryKey: ['GetPreviewPoolGlSummary', variables],
    queryFn: useFetchData<GetPreviewPoolGlSummaryQuery, GetPreviewPoolGlSummaryQueryVariables>(GetPreviewPoolGlSummaryDocument).bind(null, variables),
    ...options
  }
    )};

useGetPreviewPoolGlSummaryQuery.getKey = (variables: GetPreviewPoolGlSummaryQueryVariables) => ['GetPreviewPoolGlSummary', variables];

export const GetPreviewPoolRemittanceDocument = `
    query GetPreviewPoolRemittance($poolId: Int!, $participantClientId: Int) {
  previewPoolRemittance(
    poolId: $poolId
    participantClientId: $participantClientId
  ) {
    remittanceRows {
      clientId
      poolId
      loanId
      loanNumber
      buyerId
      reportingPeriod
      effectiveDate
      receivedDate
      currentBalance
      paymentAmount
      principalPaid
      interestPaid
      lateFeesPaid
      otherFeesPaid
      accruedInterest
      servicingFee
      platformFee
      loanStatus
      scheduledPayment
      creditLimit
      amountPastDue
      lastPaymentDate
      nextPaymentDate
      daysPastDue
      chargeOffAmount
      chargeOffDate
      chargeOffBalance
      chargeOffType
      recoveryAmount
      recoveryDate
      recoveryBalance
      isTdr
      isNonAccrual
      nonAccrualDate
      isBankruptcy
      bankruptcyChapter
      bankruptcyDate
      isFrozen
      isReversal
      delinquentEver
      loanLevelServiceFee
      cpiInsRefund
      otherFeeIndicator
      interestRate
    }
    glRows {
      poolId
      clientId
      amount
      transactionDate
      effectiveDate
      postingDate
      accountId
      debitCredit
      transactionTypeId
      transactionStatusId
      reversalReferenceId
      description
      referenceNumber
    }
  }
}
    `;

export const useGetPreviewPoolRemittanceQuery = <
      TData = GetPreviewPoolRemittanceQuery,
      TError = unknown
    >(
      variables: GetPreviewPoolRemittanceQueryVariables,
      options?: Omit<UseQueryOptions<GetPreviewPoolRemittanceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPreviewPoolRemittanceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPreviewPoolRemittanceQuery, TError, TData>(
      {
    queryKey: ['GetPreviewPoolRemittance', variables],
    queryFn: useFetchData<GetPreviewPoolRemittanceQuery, GetPreviewPoolRemittanceQueryVariables>(GetPreviewPoolRemittanceDocument).bind(null, variables),
    ...options
  }
    )};

useGetPreviewPoolRemittanceQuery.getKey = (variables: GetPreviewPoolRemittanceQueryVariables) => ['GetPreviewPoolRemittance', variables];

export const GetRemittancesDocument = `
    query GetRemittances($poolId: ID, $reportingPeriod: String) {
  remittances(poolId: $poolId, reportingPeriod: $reportingPeriod) {
    id
    clientId
    poolId
    loanId
    coreLoanId
    buyerId
    sourceFileName
    reportingPeriod
    receivedDate
    effectiveDate
    paymentAmount
    principalPaid
    interestPaid
    lateFeesPaid
    otherFeesPaid
    nextPaymentDate
    chargeOffAmount
    chargeOffDate
    chargeOffBalance
    recoveryAmount
    recoveryDate
    isTdr
    bankruptcyChapter
    bankruptcyDate
    daysPastDue
    isNonAccrual
    nonAccrualDate
    currentBalance
    accruedInterest
    currentInterestRate
    servicingFee
    platformFee
    batchId
    createdDate
    loanNumber
    loanStatus
    scheduledPayment
    creditLimit
    loanType
    loanSubcategoryId
    amountPastDue
    lastPaymentDate
    chargeOffType
    buybackAmount
    recoveryBalance
    loanLevelServiceFee
    cpiInsRefund
    otherFeeIndicator
    delinquentEver
    isBankruptcy
    isFrozen
    isReversal
    paProcessedDate
    filename
    interestRate
  }
}
    `;

export const useGetRemittancesQuery = <
      TData = GetRemittancesQuery,
      TError = unknown
    >(
      variables?: GetRemittancesQueryVariables,
      options?: Omit<UseQueryOptions<GetRemittancesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRemittancesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRemittancesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetRemittances'] : ['GetRemittances', variables],
    queryFn: useFetchData<GetRemittancesQuery, GetRemittancesQueryVariables>(GetRemittancesDocument).bind(null, variables),
    ...options
  }
    )};

useGetRemittancesQuery.getKey = (variables?: GetRemittancesQueryVariables) => variables === undefined ? ['GetRemittances'] : ['GetRemittances', variables];

export const InsertBuyersIfNotExistsDocument = `
    mutation InsertBuyersIfNotExists($clients: [CreateClientInput!]!) {
  insertClientsIfNotExists(clients: $clients) {
    id
    companyName
    contactEmail
    state
    createdDate
    modifiedDate
  }
}
    `;

export const useInsertBuyersIfNotExistsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertBuyersIfNotExistsMutation, TError, InsertBuyersIfNotExistsMutationVariables, TContext>) => {
    
    return useMutation<InsertBuyersIfNotExistsMutation, TError, InsertBuyersIfNotExistsMutationVariables, TContext>(
      {
    mutationKey: ['InsertBuyersIfNotExists'],
    mutationFn: useFetchData<InsertBuyersIfNotExistsMutation, InsertBuyersIfNotExistsMutationVariables>(InsertBuyersIfNotExistsDocument),
    ...options
  }
    )};

useInsertBuyersIfNotExistsMutation.getKey = () => ['InsertBuyersIfNotExists'];

export const MyPortfoliosDocument = `
    query myPortfolios {
  getMyPortfolios {
    isAllAccess
    institutions {
      id
      instName
      nameShort
      primaryLoanPortfolioId
      activeDataDate
    }
  }
}
    `;

export const useMyPortfoliosQuery = <
      TData = MyPortfoliosQuery,
      TError = unknown
    >(
      variables?: MyPortfoliosQueryVariables,
      options?: Omit<UseQueryOptions<MyPortfoliosQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MyPortfoliosQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MyPortfoliosQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['myPortfolios'] : ['myPortfolios', variables],
    queryFn: useFetchData<MyPortfoliosQuery, MyPortfoliosQueryVariables>(MyPortfoliosDocument).bind(null, variables),
    ...options
  }
    )};

useMyPortfoliosQuery.getKey = (variables?: MyPortfoliosQueryVariables) => variables === undefined ? ['myPortfolios'] : ['myPortfolios', variables];

export const GetDraftPoolLoansDocument = `
    query getDraftPoolLoans($portfolioId: Int!, $elementType: Report_ElementType!, $elementSetting: Report_ElementSettingsInput!, $requestId: String) {
  report_getElement(
    portfolioId: $portfolioId
    elementType: $elementType
    elementSetting: $elementSetting
    requestId: $requestId
  ) {
    requestId
    status
    error
    truncated
    tableData {
      rows {
        cells {
          value
          displayValue
        }
      }
    }
  }
}
    `;

export const useGetDraftPoolLoansQuery = <
      TData = GetDraftPoolLoansQuery,
      TError = unknown
    >(
      variables: GetDraftPoolLoansQueryVariables,
      options?: Omit<UseQueryOptions<GetDraftPoolLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDraftPoolLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetDraftPoolLoansQuery, TError, TData>(
      {
    queryKey: ['getDraftPoolLoans', variables],
    queryFn: useFetchData<GetDraftPoolLoansQuery, GetDraftPoolLoansQueryVariables>(GetDraftPoolLoansDocument).bind(null, variables),
    ...options
  }
    )};

useGetDraftPoolLoansQuery.getKey = (variables: GetDraftPoolLoansQueryVariables) => ['getDraftPoolLoans', variables];

export const GetReportTabStructureConfigDocument = `
    query getReportTabStructureConfig($portfolioId: Int!) {
  report_getTabStructureConfigs(portfolioId: $portfolioId) {
    filters {
      active {
        fields {
          name
        }
      }
    }
  }
}
    `;

export const useGetReportTabStructureConfigQuery = <
      TData = GetReportTabStructureConfigQuery,
      TError = unknown
    >(
      variables: GetReportTabStructureConfigQueryVariables,
      options?: Omit<UseQueryOptions<GetReportTabStructureConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetReportTabStructureConfigQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetReportTabStructureConfigQuery, TError, TData>(
      {
    queryKey: ['getReportTabStructureConfig', variables],
    queryFn: useFetchData<GetReportTabStructureConfigQuery, GetReportTabStructureConfigQueryVariables>(GetReportTabStructureConfigDocument).bind(null, variables),
    ...options
  }
    )};

useGetReportTabStructureConfigQuery.getKey = (variables: GetReportTabStructureConfigQueryVariables) => ['getReportTabStructureConfig', variables];

export const GetRandomLoansByTargetValueDocument = `
    query getRandomLoansByTargetValue($portfolioId: Int!, $elementSetting: Report_ElementSettingsInput!, $targetValue: Float!, $tolerancePct: Float!, $seed: Int) {
  report_getRandomLoansByTargetValue(
    portfolioId: $portfolioId
    elementSetting: $elementSetting
    targetValue: $targetValue
    tolerancePct: $tolerancePct
    seed: $seed
  ) {
    loanIdNumbers
    achievedTotal
    requestedTotal
    reachedTarget
    truncated
  }
}
    `;

export const useGetRandomLoansByTargetValueQuery = <
      TData = GetRandomLoansByTargetValueQuery,
      TError = unknown
    >(
      variables: GetRandomLoansByTargetValueQueryVariables,
      options?: Omit<UseQueryOptions<GetRandomLoansByTargetValueQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetRandomLoansByTargetValueQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetRandomLoansByTargetValueQuery, TError, TData>(
      {
    queryKey: ['getRandomLoansByTargetValue', variables],
    queryFn: useFetchData<GetRandomLoansByTargetValueQuery, GetRandomLoansByTargetValueQueryVariables>(GetRandomLoansByTargetValueDocument).bind(null, variables),
    ...options
  }
    )};

useGetRandomLoansByTargetValueQuery.getKey = (variables: GetRandomLoansByTargetValueQueryVariables) => ['getRandomLoansByTargetValue', variables];

export const GetLoanTypeDescriptionDocument = `
    query getLoanTypeDescription($portfolioId: Int!) {
  getLoanTypes(loanPortfolioId: $portfolioId) {
    loanCategory
    loanSubCategory {
      loanSubCategory
      descriptions
    }
  }
}
    `;

export const useGetLoanTypeDescriptionQuery = <
      TData = GetLoanTypeDescriptionQuery,
      TError = unknown
    >(
      variables: GetLoanTypeDescriptionQueryVariables,
      options?: Omit<UseQueryOptions<GetLoanTypeDescriptionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoanTypeDescriptionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLoanTypeDescriptionQuery, TError, TData>(
      {
    queryKey: ['getLoanTypeDescription', variables],
    queryFn: useFetchData<GetLoanTypeDescriptionQuery, GetLoanTypeDescriptionQueryVariables>(GetLoanTypeDescriptionDocument).bind(null, variables),
    ...options
  }
    )};

useGetLoanTypeDescriptionQuery.getKey = (variables: GetLoanTypeDescriptionQueryVariables) => ['getLoanTypeDescription', variables];

export const GeneratePoolNumberAndNameDocument = `
    mutation generatePoolNumberAndName($input: GeneratePoolNumberAndNameInput!) {
  generatePoolNumberAndName(input: $input) {
    poolNumber
    poolName
  }
}
    `;

export const useGeneratePoolNumberAndNameMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GeneratePoolNumberAndNameMutation, TError, GeneratePoolNumberAndNameMutationVariables, TContext>) => {
    
    return useMutation<GeneratePoolNumberAndNameMutation, TError, GeneratePoolNumberAndNameMutationVariables, TContext>(
      {
    mutationKey: ['generatePoolNumberAndName'],
    mutationFn: useFetchData<GeneratePoolNumberAndNameMutation, GeneratePoolNumberAndNameMutationVariables>(GeneratePoolNumberAndNameDocument),
    ...options
  }
    )};

useGeneratePoolNumberAndNameMutation.getKey = () => ['generatePoolNumberAndName'];

export const CreatePoolDocument = `
    mutation createPool($input: CreatePoolInput!) {
  createPool(input: $input) {
    id
    poolNumber
    poolName
    poolType
    poolStatus
    isActive
    createdDate
  }
}
    `;

export const useCreatePoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePoolMutation, TError, CreatePoolMutationVariables, TContext>) => {
    
    return useMutation<CreatePoolMutation, TError, CreatePoolMutationVariables, TContext>(
      {
    mutationKey: ['createPool'],
    mutationFn: useFetchData<CreatePoolMutation, CreatePoolMutationVariables>(CreatePoolDocument),
    ...options
  }
    )};

useCreatePoolMutation.getKey = () => ['createPool'];

export const CreatePoolFromFilterDocument = `
    mutation createPoolFromFilter($input: CreatePoolFromFilterInput!) {
  createPoolFromFilter(input: $input) {
    id
    poolNumber
    poolName
    poolType
    poolStatus
    isActive
    createdDate
  }
}
    `;

export const useCreatePoolFromFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePoolFromFilterMutation, TError, CreatePoolFromFilterMutationVariables, TContext>) => {
    
    return useMutation<CreatePoolFromFilterMutation, TError, CreatePoolFromFilterMutationVariables, TContext>(
      {
    mutationKey: ['createPoolFromFilter'],
    mutationFn: useFetchData<CreatePoolFromFilterMutation, CreatePoolFromFilterMutationVariables>(CreatePoolFromFilterDocument),
    ...options
  }
    )};

useCreatePoolFromFilterMutation.getKey = () => ['createPoolFromFilter'];

export const CreatePoolListingDocument = `
    mutation createPoolListing($input: CreatePoolListingInput!) {
  createPoolListing(input: $input) {
    id
    poolId
    price
    listingStage
    listingStatus
    isActive
    createdDate
  }
}
    `;

export const useCreatePoolListingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePoolListingMutation, TError, CreatePoolListingMutationVariables, TContext>) => {
    
    return useMutation<CreatePoolListingMutation, TError, CreatePoolListingMutationVariables, TContext>(
      {
    mutationKey: ['createPoolListing'],
    mutationFn: useFetchData<CreatePoolListingMutation, CreatePoolListingMutationVariables>(CreatePoolListingDocument),
    ...options
  }
    )};

useCreatePoolListingMutation.getKey = () => ['createPoolListing'];

export const UpdatePoolMetricsDocument = `
    mutation updatePoolMetrics($id: Int!, $input: UpdatePoolMetricsInput!) {
  updatePoolMetrics(id: $id, input: $input) {
    id
    war
    netYield
    waFico
    waLtv
    warl
    poolName
    loanCount
  }
}
    `;

export const useUpdatePoolMetricsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePoolMetricsMutation, TError, UpdatePoolMetricsMutationVariables, TContext>) => {
    
    return useMutation<UpdatePoolMetricsMutation, TError, UpdatePoolMetricsMutationVariables, TContext>(
      {
    mutationKey: ['updatePoolMetrics'],
    mutationFn: useFetchData<UpdatePoolMetricsMutation, UpdatePoolMetricsMutationVariables>(UpdatePoolMetricsDocument),
    ...options
  }
    )};

useUpdatePoolMetricsMutation.getKey = () => ['updatePoolMetrics'];

export const AddLoansToPoolFromFilterDocument = `
    mutation addLoansToPoolFromFilter($input: AddLoansToPoolFromFilterInput!) {
  addLoansToPoolFromFilter(input: $input) {
    id
    poolName
    loanCount
  }
}
    `;

export const useAddLoansToPoolFromFilterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddLoansToPoolFromFilterMutation, TError, AddLoansToPoolFromFilterMutationVariables, TContext>) => {
    
    return useMutation<AddLoansToPoolFromFilterMutation, TError, AddLoansToPoolFromFilterMutationVariables, TContext>(
      {
    mutationKey: ['addLoansToPoolFromFilter'],
    mutationFn: useFetchData<AddLoansToPoolFromFilterMutation, AddLoansToPoolFromFilterMutationVariables>(AddLoansToPoolFromFilterDocument),
    ...options
  }
    )};

useAddLoansToPoolFromFilterMutation.getKey = () => ['addLoansToPoolFromFilter'];

export const CheckExistingPoolParticipantDocument = `
    query CheckExistingPoolParticipant($poolId: ID!, $buyerId: Int!) {
  poolParticipants(poolId: $poolId, buyerId: $buyerId) {
    id
    poolId
    buyerId
    percentage
    isSeller
    isServicer
  }
}
    `;

export const useCheckExistingPoolParticipantQuery = <
      TData = CheckExistingPoolParticipantQuery,
      TError = unknown
    >(
      variables: CheckExistingPoolParticipantQueryVariables,
      options?: Omit<UseQueryOptions<CheckExistingPoolParticipantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckExistingPoolParticipantQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckExistingPoolParticipantQuery, TError, TData>(
      {
    queryKey: ['CheckExistingPoolParticipant', variables],
    queryFn: useFetchData<CheckExistingPoolParticipantQuery, CheckExistingPoolParticipantQueryVariables>(CheckExistingPoolParticipantDocument).bind(null, variables),
    ...options
  }
    )};

useCheckExistingPoolParticipantQuery.getKey = (variables: CheckExistingPoolParticipantQueryVariables) => ['CheckExistingPoolParticipant', variables];

export const UpdatePoolListingDocument = `
    mutation UpdatePoolListing($poolId: ID!, $input: UpdatePoolListingInput!) {
  updatePoolListing(poolId: $poolId, input: $input) {
    id
    poolId
    price
    minBuyinType
    minBuyinValue
    listingType
    institutionNameDisclosure
    dueDiligencePeriod
    dueDiligencePeriodDays
    carveOutPermitted
    recourseType
    listingStage
    listingStatus
  }
}
    `;

export const useUpdatePoolListingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePoolListingMutation, TError, UpdatePoolListingMutationVariables, TContext>) => {
    
    return useMutation<UpdatePoolListingMutation, TError, UpdatePoolListingMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePoolListing'],
    mutationFn: useFetchData<UpdatePoolListingMutation, UpdatePoolListingMutationVariables>(UpdatePoolListingDocument),
    ...options
  }
    )};

useUpdatePoolListingMutation.getKey = () => ['UpdatePoolListing'];

export const UpdatePoolServicingDocument = `
    mutation UpdatePoolServicing($id: Int!, $input: UpdatePoolInput!) {
  updatePool(id: $id, input: $input) {
    id
    servicingFeePercentage
  }
}
    `;

export const useUpdatePoolServicingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePoolServicingMutation, TError, UpdatePoolServicingMutationVariables, TContext>) => {
    
    return useMutation<UpdatePoolServicingMutation, TError, UpdatePoolServicingMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePoolServicing'],
    mutationFn: useFetchData<UpdatePoolServicingMutation, UpdatePoolServicingMutationVariables>(UpdatePoolServicingDocument),
    ...options
  }
    )};

useUpdatePoolServicingMutation.getKey = () => ['UpdatePoolServicing'];

export const CreatePoolParticipantDocument = `
    mutation CreatePoolParticipant($input: CreatePoolParticipantInput!) {
  createPoolParticipant(input: $input) {
    id
    poolId
    buyerId
    percentage
    isSeller
    isServicer
  }
}
    `;

export const useCreatePoolParticipantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePoolParticipantMutation, TError, CreatePoolParticipantMutationVariables, TContext>) => {
    
    return useMutation<CreatePoolParticipantMutation, TError, CreatePoolParticipantMutationVariables, TContext>(
      {
    mutationKey: ['CreatePoolParticipant'],
    mutationFn: useFetchData<CreatePoolParticipantMutation, CreatePoolParticipantMutationVariables>(CreatePoolParticipantDocument),
    ...options
  }
    )};

useCreatePoolParticipantMutation.getKey = () => ['CreatePoolParticipant'];

export const UpdatePoolParticipantDocument = `
    mutation UpdatePoolParticipant($poolId: ID!, $buyerId: Int!, $input: UpdatePoolParticipantInput!) {
  updatePoolParticipantByPoolByBuyer(
    poolId: $poolId
    buyerId: $buyerId
    input: $input
  ) {
    id
    poolId
    buyerId
    percentage
    isSeller
  }
}
    `;

export const useUpdatePoolParticipantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePoolParticipantMutation, TError, UpdatePoolParticipantMutationVariables, TContext>) => {
    
    return useMutation<UpdatePoolParticipantMutation, TError, UpdatePoolParticipantMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePoolParticipant'],
    mutationFn: useFetchData<UpdatePoolParticipantMutation, UpdatePoolParticipantMutationVariables>(UpdatePoolParticipantDocument),
    ...options
  }
    )};

useUpdatePoolParticipantMutation.getKey = () => ['UpdatePoolParticipant'];

export const GetMarketplaceLoansDocument = `
    query GetMarketplaceLoans($isActive: Boolean) {
  loans(isActive: $isActive) {
    id
    loanNumber
    originationDate
    currentBalance
    interestRate
  }
}
    `;

export const useGetMarketplaceLoansQuery = <
      TData = GetMarketplaceLoansQuery,
      TError = unknown
    >(
      variables?: GetMarketplaceLoansQueryVariables,
      options?: Omit<UseQueryOptions<GetMarketplaceLoansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMarketplaceLoansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMarketplaceLoansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMarketplaceLoans'] : ['GetMarketplaceLoans', variables],
    queryFn: useFetchData<GetMarketplaceLoansQuery, GetMarketplaceLoansQueryVariables>(GetMarketplaceLoansDocument).bind(null, variables),
    ...options
  }
    )};

useGetMarketplaceLoansQuery.getKey = (variables?: GetMarketplaceLoansQueryVariables) => variables === undefined ? ['GetMarketplaceLoans'] : ['GetMarketplaceLoans', variables];

export const GetPoolsForSellPageDocument = `
    query GetPoolsForSellPage($clientId: Int, $isActiveOnly: Boolean) {
  pools(clientId: $clientId, isActiveOnly: $isActiveOnly) {
    id
    poolNumber
    poolName
    poolType
    loanCount
    balance
    createdDate
    loanPortfolioId
    listing {
      id
      listingStage
      isActive
      price
    }
  }
}
    `;

export const useGetPoolsForSellPageQuery = <
      TData = GetPoolsForSellPageQuery,
      TError = unknown
    >(
      variables?: GetPoolsForSellPageQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolsForSellPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolsForSellPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolsForSellPageQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPoolsForSellPage'] : ['GetPoolsForSellPage', variables],
    queryFn: useFetchData<GetPoolsForSellPageQuery, GetPoolsForSellPageQueryVariables>(GetPoolsForSellPageDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolsForSellPageQuery.getKey = (variables?: GetPoolsForSellPageQueryVariables) => variables === undefined ? ['GetPoolsForSellPage'] : ['GetPoolsForSellPage', variables];

export const GetPoolForSellEditDocument = `
    query GetPoolForSellEdit($id: Int!) {
  pool(id: $id) {
    id
    loans {
      id
      loanNumber
    }
    poolLoans {
      id
      loanId
    }
  }
}
    `;

export const useGetPoolForSellEditQuery = <
      TData = GetPoolForSellEditQuery,
      TError = unknown
    >(
      variables: GetPoolForSellEditQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolForSellEditQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolForSellEditQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolForSellEditQuery, TError, TData>(
      {
    queryKey: ['GetPoolForSellEdit', variables],
    queryFn: useFetchData<GetPoolForSellEditQuery, GetPoolForSellEditQueryVariables>(GetPoolForSellEditDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolForSellEditQuery.getKey = (variables: GetPoolForSellEditQueryVariables) => ['GetPoolForSellEdit', variables];

export const GetPoolForSellPageDocument = `
    query GetPoolForSellPage($id: Int!) {
  pool(id: $id) {
    id
    poolName
    createdDate
    loanCount
    grossYield
    poolType
    servicingFeePercentage
    listing {
      listingStage
      settlementType
      recourseType
      price
      dueDiligencePeriod
      dueDiligencePeriodDays
      carveOutPermitted
      servicingType
    }
    loans {
      currentBalance
      id
      loanNumber
    }
    participants {
      isSeller
      percentage
    }
  }
}
    `;

export const useGetPoolForSellPageQuery = <
      TData = GetPoolForSellPageQuery,
      TError = unknown
    >(
      variables: GetPoolForSellPageQueryVariables,
      options?: Omit<UseQueryOptions<GetPoolForSellPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoolForSellPageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoolForSellPageQuery, TError, TData>(
      {
    queryKey: ['GetPoolForSellPage', variables],
    queryFn: useFetchData<GetPoolForSellPageQuery, GetPoolForSellPageQueryVariables>(GetPoolForSellPageDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoolForSellPageQuery.getKey = (variables: GetPoolForSellPageQueryVariables) => ['GetPoolForSellPage', variables];

export const DeletePoolLoanDocument = `
    mutation DeletePoolLoan($id: ID!) {
  deletePoolLoan(id: $id)
}
    `;

export const useDeletePoolLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeletePoolLoanMutation, TError, DeletePoolLoanMutationVariables, TContext>) => {
    
    return useMutation<DeletePoolLoanMutation, TError, DeletePoolLoanMutationVariables, TContext>(
      {
    mutationKey: ['DeletePoolLoan'],
    mutationFn: useFetchData<DeletePoolLoanMutation, DeletePoolLoanMutationVariables>(DeletePoolLoanDocument),
    ...options
  }
    )};

useDeletePoolLoanMutation.getKey = () => ['DeletePoolLoan'];

export const UpdatePoolDocument = `
    mutation UpdatePool($id: Int!, $input: UpdatePoolInput!) {
  updatePool(id: $id, input: $input) {
    id
    poolName
    poolType
    loanCount
    createdDate
    listing {
      id
      listingStage
    }
  }
}
    `;

export const useUpdatePoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePoolMutation, TError, UpdatePoolMutationVariables, TContext>) => {
    
    return useMutation<UpdatePoolMutation, TError, UpdatePoolMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePool'],
    mutationFn: useFetchData<UpdatePoolMutation, UpdatePoolMutationVariables>(UpdatePoolDocument),
    ...options
  }
    )};

useUpdatePoolMutation.getKey = () => ['UpdatePool'];

export const BrowsePoolBuyRequestsDocument = `
    query BrowsePoolBuyRequests {
  browsePoolBuyRequests {
    id
    assetClass
    poolSizeMin
    poolSizeMax
    description
    targetYield
    createdDate
    hasInquired
    status
  }
}
    `;

export const useBrowsePoolBuyRequestsQuery = <
      TData = BrowsePoolBuyRequestsQuery,
      TError = unknown
    >(
      variables?: BrowsePoolBuyRequestsQueryVariables,
      options?: Omit<UseQueryOptions<BrowsePoolBuyRequestsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrowsePoolBuyRequestsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrowsePoolBuyRequestsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['BrowsePoolBuyRequests'] : ['BrowsePoolBuyRequests', variables],
    queryFn: useFetchData<BrowsePoolBuyRequestsQuery, BrowsePoolBuyRequestsQueryVariables>(BrowsePoolBuyRequestsDocument).bind(null, variables),
    ...options
  }
    )};

useBrowsePoolBuyRequestsQuery.getKey = (variables?: BrowsePoolBuyRequestsQueryVariables) => variables === undefined ? ['BrowsePoolBuyRequests'] : ['BrowsePoolBuyRequests', variables];

export const CreatePoolBuyRequestInquiryDocument = `
    mutation CreatePoolBuyRequestInquiry($input: CreatePoolBuyRequestInquiryInput!) {
  createPoolBuyRequestInquiry(input: $input) {
    poolBuyRequestId
  }
}
    `;

export const useCreatePoolBuyRequestInquiryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePoolBuyRequestInquiryMutation, TError, CreatePoolBuyRequestInquiryMutationVariables, TContext>) => {
    
    return useMutation<CreatePoolBuyRequestInquiryMutation, TError, CreatePoolBuyRequestInquiryMutationVariables, TContext>(
      {
    mutationKey: ['CreatePoolBuyRequestInquiry'],
    mutationFn: useFetchData<CreatePoolBuyRequestInquiryMutation, CreatePoolBuyRequestInquiryMutationVariables>(CreatePoolBuyRequestInquiryDocument),
    ...options
  }
    )};

useCreatePoolBuyRequestInquiryMutation.getKey = () => ['CreatePoolBuyRequestInquiry'];

export const AgreementVersionHistoryDocument = `
    query agreementVersionHistory {
  agreement_getVersionHistory {
    ...AgreementVersionFields
  }
}
    ${AgreementVersionFieldsFragmentDoc}`;

export const useAgreementVersionHistoryQuery = <
      TData = AgreementVersionHistoryQuery,
      TError = unknown
    >(
      variables?: AgreementVersionHistoryQueryVariables,
      options?: Omit<UseQueryOptions<AgreementVersionHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AgreementVersionHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AgreementVersionHistoryQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['agreementVersionHistory'] : ['agreementVersionHistory', variables],
    queryFn: useFetchData<AgreementVersionHistoryQuery, AgreementVersionHistoryQueryVariables>(AgreementVersionHistoryDocument).bind(null, variables),
    ...options
  }
    )};

useAgreementVersionHistoryQuery.getKey = (variables?: AgreementVersionHistoryQueryVariables) => variables === undefined ? ['agreementVersionHistory'] : ['agreementVersionHistory', variables];

export const PublishTermsVersionDocument = `
    mutation publishTermsVersion($input: Agreement_PublishVersionInput!) {
  agreement_publishVersion(input: $input) {
    ...AgreementVersionFields
  }
}
    ${AgreementVersionFieldsFragmentDoc}`;

export const usePublishTermsVersionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishTermsVersionMutation, TError, PublishTermsVersionMutationVariables, TContext>) => {
    
    return useMutation<PublishTermsVersionMutation, TError, PublishTermsVersionMutationVariables, TContext>(
      {
    mutationKey: ['publishTermsVersion'],
    mutationFn: useFetchData<PublishTermsVersionMutation, PublishTermsVersionMutationVariables>(PublishTermsVersionDocument),
    ...options
  }
    )};

usePublishTermsVersionMutation.getKey = () => ['publishTermsVersion'];

export const AgreementExportAcceptancesDocument = `
    query agreementExportAcceptances($input: Agreement_ExportAcceptancesInput!) {
  agreement_exportAcceptances(input: $input) {
    ...AgreementAcceptanceRecordFields
  }
}
    ${AgreementAcceptanceRecordFieldsFragmentDoc}`;

export const useAgreementExportAcceptancesQuery = <
      TData = AgreementExportAcceptancesQuery,
      TError = unknown
    >(
      variables: AgreementExportAcceptancesQueryVariables,
      options?: Omit<UseQueryOptions<AgreementExportAcceptancesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AgreementExportAcceptancesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AgreementExportAcceptancesQuery, TError, TData>(
      {
    queryKey: ['agreementExportAcceptances', variables],
    queryFn: useFetchData<AgreementExportAcceptancesQuery, AgreementExportAcceptancesQueryVariables>(AgreementExportAcceptancesDocument).bind(null, variables),
    ...options
  }
    )};

useAgreementExportAcceptancesQuery.getKey = (variables: AgreementExportAcceptancesQueryVariables) => ['agreementExportAcceptances', variables];

export const InstitutionMemberMarketplaceRightsDocument = `
    query institutionMemberMarketplaceRights($institutionId: Int!) {
  getInstitutionMemberRights(institutionId: $institutionId) {
    id
    firstName
    lastName
    username
    marketplaceRights {
      basicAccess
      initiateInterest
      approveInterest
      publishListing
      reconcileData
      approveRemittance
      importSavedGroupAsPool
      mpAdminAccess
    }
  }
}
    `;

export const useInstitutionMemberMarketplaceRightsQuery = <
      TData = InstitutionMemberMarketplaceRightsQuery,
      TError = unknown
    >(
      variables: InstitutionMemberMarketplaceRightsQueryVariables,
      options?: Omit<UseQueryOptions<InstitutionMemberMarketplaceRightsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InstitutionMemberMarketplaceRightsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InstitutionMemberMarketplaceRightsQuery, TError, TData>(
      {
    queryKey: ['institutionMemberMarketplaceRights', variables],
    queryFn: useFetchData<InstitutionMemberMarketplaceRightsQuery, InstitutionMemberMarketplaceRightsQueryVariables>(InstitutionMemberMarketplaceRightsDocument).bind(null, variables),
    ...options
  }
    )};

useInstitutionMemberMarketplaceRightsQuery.getKey = (variables: InstitutionMemberMarketplaceRightsQueryVariables) => ['institutionMemberMarketplaceRights', variables];

export const AddLeadershipMemberDocument = `
    mutation addLeadershipMember($institutionId: Int!, $member: LeadershipMemberInput!) {
  addLeadershipMember(institutionId: $institutionId, member: $member) {
    id
    firstName
    lastName
    title
    startDate
  }
}
    `;

export const useAddLeadershipMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddLeadershipMemberMutation, TError, AddLeadershipMemberMutationVariables, TContext>) => {
    
    return useMutation<AddLeadershipMemberMutation, TError, AddLeadershipMemberMutationVariables, TContext>(
      {
    mutationKey: ['addLeadershipMember'],
    mutationFn: useFetchData<AddLeadershipMemberMutation, AddLeadershipMemberMutationVariables>(AddLeadershipMemberDocument),
    ...options
  }
    )};

useAddLeadershipMemberMutation.getKey = () => ['addLeadershipMember'];

export const UpdateLeadershipMemberDocument = `
    mutation updateLeadershipMember($institutionId: Int!, $id: Int!, $member: LeadershipMemberInput!) {
  updateLeadershipMember(institutionId: $institutionId, id: $id, member: $member) {
    id
    firstName
    lastName
    title
    startDate
  }
}
    `;

export const useUpdateLeadershipMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLeadershipMemberMutation, TError, UpdateLeadershipMemberMutationVariables, TContext>) => {
    
    return useMutation<UpdateLeadershipMemberMutation, TError, UpdateLeadershipMemberMutationVariables, TContext>(
      {
    mutationKey: ['updateLeadershipMember'],
    mutationFn: useFetchData<UpdateLeadershipMemberMutation, UpdateLeadershipMemberMutationVariables>(UpdateLeadershipMemberDocument),
    ...options
  }
    )};

useUpdateLeadershipMemberMutation.getKey = () => ['updateLeadershipMember'];

export const ReorderLeadershipMembersDocument = `
    mutation reorderLeadershipMembers($institutionId: Int!, $memberOrder: [Int!]!) {
  reorderLeadershipMembers(
    institutionId: $institutionId
    memberOrder: $memberOrder
  ) {
    firstName
    lastName
    title
    startDate
  }
}
    `;

export const useReorderLeadershipMembersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderLeadershipMembersMutation, TError, ReorderLeadershipMembersMutationVariables, TContext>) => {
    
    return useMutation<ReorderLeadershipMembersMutation, TError, ReorderLeadershipMembersMutationVariables, TContext>(
      {
    mutationKey: ['reorderLeadershipMembers'],
    mutationFn: useFetchData<ReorderLeadershipMembersMutation, ReorderLeadershipMembersMutationVariables>(ReorderLeadershipMembersDocument),
    ...options
  }
    )};

useReorderLeadershipMembersMutation.getKey = () => ['reorderLeadershipMembers'];

export const DeleteLeadershipMemberDocument = `
    mutation deleteLeadershipMember($institutionId: Int!, $id: Int!) {
  deleteLeadershipMember(institutionId: $institutionId, id: $id)
}
    `;

export const useDeleteLeadershipMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteLeadershipMemberMutation, TError, DeleteLeadershipMemberMutationVariables, TContext>) => {
    
    return useMutation<DeleteLeadershipMemberMutation, TError, DeleteLeadershipMemberMutationVariables, TContext>(
      {
    mutationKey: ['deleteLeadershipMember'],
    mutationFn: useFetchData<DeleteLeadershipMemberMutation, DeleteLeadershipMemberMutationVariables>(DeleteLeadershipMemberDocument),
    ...options
  }
    )};

useDeleteLeadershipMemberMutation.getKey = () => ['deleteLeadershipMember'];

export const GetInstitutionSignatureStatusDocument = `
    query getInstitutionSignatureStatus($institutionId: Int!) {
  SignatureService_getInstitutionSignatureStatus(institutionId: $institutionId) {
    institutionId
    signed
    signatureRecord {
      workflowId
      status
      completedAt
    }
  }
}
    `;

export const useGetInstitutionSignatureStatusQuery = <
      TData = GetInstitutionSignatureStatusQuery,
      TError = unknown
    >(
      variables: GetInstitutionSignatureStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetInstitutionSignatureStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInstitutionSignatureStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInstitutionSignatureStatusQuery, TError, TData>(
      {
    queryKey: ['getInstitutionSignatureStatus', variables],
    queryFn: useFetchData<GetInstitutionSignatureStatusQuery, GetInstitutionSignatureStatusQueryVariables>(GetInstitutionSignatureStatusDocument).bind(null, variables),
    ...options
  }
    )};

useGetInstitutionSignatureStatusQuery.getKey = (variables: GetInstitutionSignatureStatusQueryVariables) => ['getInstitutionSignatureStatus', variables];

export const GetInstitutionProfileDocument = `
    query getInstitutionProfile($institutionId: Int!) {
  getMarketplaceInstitution(id: $institutionId) {
    name
    address
    city
    stateAbbrev
    zipCode
  }
}
    `;

export const useGetInstitutionProfileQuery = <
      TData = GetInstitutionProfileQuery,
      TError = unknown
    >(
      variables: GetInstitutionProfileQueryVariables,
      options?: Omit<UseQueryOptions<GetInstitutionProfileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInstitutionProfileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInstitutionProfileQuery, TError, TData>(
      {
    queryKey: ['getInstitutionProfile', variables],
    queryFn: useFetchData<GetInstitutionProfileQuery, GetInstitutionProfileQueryVariables>(GetInstitutionProfileDocument).bind(null, variables),
    ...options
  }
    )};

useGetInstitutionProfileQuery.getKey = (variables: GetInstitutionProfileQueryVariables) => ['getInstitutionProfile', variables];

export const InstitutionDocument = `
    query institution($institutionId: Int!) {
  getMarketplaceInstitution(id: $institutionId) {
    name
    institutionType
    cuNumber
    city
    stateAbbrev
    url
    leadership {
      id
      firstName
      lastName
      title
      startDate
    }
  }
}
    `;

export const useInstitutionQuery = <
      TData = InstitutionQuery,
      TError = unknown
    >(
      variables: InstitutionQueryVariables,
      options?: Omit<UseQueryOptions<InstitutionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InstitutionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InstitutionQuery, TError, TData>(
      {
    queryKey: ['institution', variables],
    queryFn: useFetchData<InstitutionQuery, InstitutionQueryVariables>(InstitutionDocument).bind(null, variables),
    ...options
  }
    )};

useInstitutionQuery.getKey = (variables: InstitutionQueryVariables) => ['institution', variables];

export const InstitutionLeadershipDocument = `
    query institutionLeadership($institutionId: Int!) {
  getInstitutionLeadership(institutionId: $institutionId) {
    id
    firstName
    lastName
    title
    startDate
  }
}
    `;

export const useInstitutionLeadershipQuery = <
      TData = InstitutionLeadershipQuery,
      TError = unknown
    >(
      variables: InstitutionLeadershipQueryVariables,
      options?: Omit<UseQueryOptions<InstitutionLeadershipQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InstitutionLeadershipQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InstitutionLeadershipQuery, TError, TData>(
      {
    queryKey: ['institutionLeadership', variables],
    queryFn: useFetchData<InstitutionLeadershipQuery, InstitutionLeadershipQueryVariables>(InstitutionLeadershipDocument).bind(null, variables),
    ...options
  }
    )};

useInstitutionLeadershipQuery.getKey = (variables: InstitutionLeadershipQueryVariables) => ['institutionLeadership', variables];
